import Vue from 'vue';
import { get, getToken, post, uploadFile, getSVGData, addClickCount } from '../utils/api';
import {
  effectsTransformer,
  fragmentsTransformer,
  matchFilter,
  normalizeEffects,
  normalizeAudios,
  marginFactors,
  getCropDuration,
  fitCanvas,
  getEffectName,
  labelPrefixes,
  normalizeSVGSource,
  normalizeFragments
} from '../utils/util';

import { generateVideoData } from '../utils/paramParsers';
import { betweenDelta, clamp, getAngle, getAudioDuration, getImageAspectRatio, rotateBy, rotateRect } from '../utils';
import textEffectMap, { effectParams } from '../utils/textEffectMap';
import { shapeParams } from '../utils/shapes';
import * as moveEffect from '../utils/moveEffect';
import { message, Modal } from "ant-design-vue";
import getLottie from '../utils/getLottie';
import { WordArtParams } from '../utils/wordArtParams';
import { adjustSize } from '@/utils/detectLines';

import {
  getSeoTitle,
  clearSeoSearch,
  addSubtitleTrack,
  loadLanguages,
  textToAudio,
  processLoadTranslations,
  loadTranslations,
  processBatchRemoveTrack,
  autoMaticprocessBatchRemoveTrack,
  processRemoveTrack,
  removeSelectedTrack,
  getUploadSpace,
  uploadToOSS,
  stampPadding,
  addCustomTTS,
  changeCustomTTS,
  removeCustomTTS,
  getUserMeal
} from './storeUtils';
const getVideoInfo = (url) => {
  return new Promise(resolve => {
    const video = document.createElement("video");
    video.oncanplay = () => {
      console.log(video.videoHeight);
      resolve([null, { width: video.videoWidth, height: video.videoHeight }]);
    };
    video.onerror = err => {
      resolve([err, null]);
    };
    video.src = url;
  });
};
const generatePositionModal = ({ title, options, defaultValue, done }) => new Promise(resolve => {
  let value = defaultValue;
  const modalContent = h => h('a-form-item', {
    style: {
      margin: '16px 0'
    },
    attrs: {
      labelCol: { span: 6 },
      labelAlign: 'left',
      label: '片段位置',
      wrapperCol: { span: 18 }
    }
  }, [
    h('a-select', {
      style: { width: '100%' },
      attrs: {
        value,
        options
      },
      on: {
        change(e) {
          value = e;
          modal.update({
            content: modalContent
          });
        }
      }
    })
  ]);
  const modal = Modal.confirm({
    title,
    content: modalContent,
    icon: () => null,
    onOk() {
      if (done) {
        done(value);
      }
      resolve(true);
    },
    onCancel() {
      resolve(false);
    }
  });
});

let videoTemplateCounter = 0;
let fragTemplateCounter = 0;
let presetListCounter = 0;
let musicListCounter = 0;
let materialListCounter = 0;

export default {
  selectStampType({ commit }, stampType) {
    commit('handleStampType', stampType)
  },
  login: async ({ commit }) => {
    const token = await getToken();
    commit('handleToken', token);
  },
  // getUserCount: async () => {
  //   return post('getusercount')
  // },
  getEditCount: async ({ state, commit }, editTotal) => {
    const { id } = state;
    commit('handleLoading', true);
    const { again_num, ms_cover, thumbnail, translated, subtitle, text } = await get('video/basics', { id });
    if (again_num >= editTotal) {
      message.error('该视频更改次数已用完');
      throw 'again num is zero'
    }
    commit('handleLoading', false);

    return { again_num, ms_cover, thumbnail, translated, subtitle, text };
  },
  async saveDraft({ state, getters, commit }) {
    const { videoName, id, draftId, fragments, readonly } = state;
    const { aspectRatio, ttsFontSizes, stampPadding, maxStampSize } = getters;
    if (readonly) {
      message.error('以只读模式打开时，无法保存草稿。');
      return false;
    }

    normalizeFragments(fragments);
    let done = true;

    commit('handleLoading', true);
    let data;

    try {
      data = {
        ...(id
          ? { video_id: id }
          : { id: draftId || undefined }
        ), // skip passing in id on creation
        type: 6,
        ...await generateVideoData(state, { aspectRatio, ttsFontSizes, loadFile: true, stampPadding, maxStampSize, reportSize: true })
      };
      // console.log(JSON.stringify(data));
      console.log( state?.record?.recordIndex)
      if (!isNaN(state?.record?.recordIndex)) {
        data.params.recordIndex = state?.record?.recordIndex
      }
      data.track_id = state.trackId
      console.log('保存草稿', data);
      const { id: respId } = await post('video-draft/single', data);
      if (!draftId) { // neither video id nor draft id
        commit('handleDraftId', respId);
        history.replaceState(null, '', `/timelinepreview?draftid=${respId}`);
      }
      if (!videoName) {
        commit('handleVideoName', data.video_name);
      }
    } catch (e) {
      if (!data) {
        message.error('草稿数据生成失败');
      }
      console.log(e);
      done = false;
    }
    commit('handleLoading', false);

    return done;
  },
  async saveDraftNotify({ dispatch }) {
    const done = await dispatch('saveDraft');
    if (done) {
      message.info('草稿保存成功，可以在 “我的草稿” 中查看。');
    }
  },
  async saveBackup({ state, getters, commit }) {
    const { aspectRatio, ttsFontSizes, stampPadding, maxStampSize } = getters;
    commit('handleLoading', true);

    try {
      const data = {
        v_id: 0,
        draft_id: 0,
        type: 6,
        ...await generateVideoData(state, { aspectRatio, ttsFontSizes, stampPadding, maxStampSize })
      };
      await post('video/auto_handle', data);
    } catch (e) { }
    commit('handleLoading', false);
  },
  updateVideo: async ({ state, getters, commit }, textParams) => {
    commit('handlePosterVisible', false);
    const { id, draftId, thumbnail, ms_cover, fragments } = state;
    const { aspectRatio, ttsFontSizes, stampPadding, maxStampSize } = getters;
    normalizeFragments(fragments);
    commit('handleLoading', true);
    let data;

    try {
      data = {
        id: id || undefined, // skip passing in id on creation
        draft_id: draftId || undefined,
        thumbnail: thumbnail || undefined,
        ms_cover: thumbnail ? undefined : ms_cover || 0,
        text: {
          ossWordPath: textParams && textParams.thumbnail,
          wordParams: state.coverParams,
          hasStamp: textParams && +textParams.hasStamp || 0
        },
        ...await generateVideoData(state, { aspectRatio, ttsFontSizes, loadFile: true, stampPadding, maxStampSize, reportSize: true })
      };
      if (thumbnail) {
        await getImageAspectRatio(thumbnail, img => {
          data.thumbnailSize = [img.naturalWidth, img.naturalHeight];
        });
      }
      if (state.isFisher) {
        data.type = 24
        console.log('state.isFisher', state.fisherInfo)
        if (state.fisherInfo.type === 'digitalHuman') {
          data.type = 26
        }
      }
      data.track_id = state.trackId
      const res = await post('saveVideo', data);
      console.log('saveVideo res', res);
      message.info({
        content: '视频创建成功!',
        duration: 0
      });

      window.onbeforeunload = null;
      setTimeout(() => {
        if (state.isFisher && state.backUrl) {
          window.location.href = state.backUrl
          return
        }
        window.location.href = '/lists'
      }, 2e3)
    } catch (e) {
      if (!data) {
        message.error('视频数据生成失败');
      }
      console.log(e);
      commit('handleLoading', false);
    }
  },
  async saveVideoTemplate({ state, getters, commit }) {
    const { templateId, fragments } = state;
    const { aspectRatio, ttsFontSizes, stampPadding, maxStampSize } = getters;

    normalizeFragments(fragments);

    commit('handleLoading', true);
    const data = {
      id: templateId,
      ...await generateVideoData(state, { aspectRatio, ttsFontSizes, loadFile: true, stampPadding, maxStampSize, reportSize: true })
    };
    data.name = data.video_name;
    delete data.video_name;

    try {
      await post('template/uptemplate', data);
      Modal.info({
        title: '视频模板保存成功',
        content: '下次可以在 “我的模板” 中找到此模板。',
        maskClosable: true
      });
    } catch (e) { }
    commit('handleLoading', false);
  },
  getMusicList: async ({ commit, state }, { order = 'order', page = 1, material = '', u_id = '0', gt_duration = null, lt_duration = null, category }) => {
    ++musicListCounter;
    let counter = musicListCounter;

    const data = await post('find-material', {
      page,
      limit: 20,
      material_type: '6',
      u_id,
      order: u_id === '' ? 'id' : order,
      material,
      orderby: 'desc',
      gt_duration,
      lt_duration,
      category
    }, true);

    if (!data.lists) {
      return;
    }
    if (counter === musicListCounter) {
      const musicList = page === 1 ? data.lists : [...state.musicList, ...data.lists];
      console.log(musicList)
      commit('handleMusicList', musicList)
      return { lastPage: page * 20 >= data.listsCount };
    }
  },
  getDefaultMusic: async ({ commit, state }) => {
    const data = await post('find-material', {
      page: 1,
      limit: 1,
      material_type: '6',
      u_id: '0',
      order: 'order',
      material: '系统音乐1',
    }, true);

    if (!state.currentMusic.id && data.lists[0]) {
      commit('handleCurrentMusic', data.lists[0])
    }

    // if (!state.myVideoMusic.id && data.lists[0]) {
    //   commit('handleMyVideoMusic', data.lists[0])
    // }

    if (!data.lists) {
      return;
    }
  },
  addFragmentAudio({ state, getters, commit }, audio) {
    const fragment = getters.activeFragment;
    let duration = clamp(
      audio.duration || Math.min(6e3, fragment.duration),
      400,
      fragment.duration
    );
    let start = clamp(
        state.currentProgress - fragment.start,
        0,
        Math.max(fragment.duration - duration, 0)
    )
    if(!isNaN(audio.start)) {
      start = audio.start
      duration = audio.duration
    }
    const processed = {
      ...audio,
      start,
      duration,
      backgroundVolume: 100
    };

    let key = audio.id;
    if (!key) {
      key = '' + (+new Date());
      processed.id = key;
    }

    commit('handleAudios', {
      ...state.audios,
      [key]: processed
    });

    fragment.audios.push(key);

    commit('handleAudioSelect', key);
  },
  setAudioEditing({ commit }, value) {
    commit('handleAudioEdit', value);
    if (value) {
      commit('handleCurrentIcon', 'music');
      commit('handleCurrentMenu', 'MusicMenu');
    }
  },
  replaceFragmentAudio({ state, commit }, audio) {
    const id = state.selectedAudioId;

    const prevAudio = state.audios[id];
    const processed = {
      ...prevAudio,
      src: audio.src,
      crop: audio.crop,
      name: audio.name,
      audioId: audio.audioId
    };

    commit('handleAudios', {
      ...state.audios,
      [id]: processed
    });

    commit('handleAudioSelect', id);
    commit('handleAudioEdit', false);
  },
  removeFragmentAudio({ state, getters, commit }) {
    const id = state.selectedAudioId;
    const fragment = getters.activeFragment;
    const audios = { ...state.audios };
    delete audios[id];

    commit('handleAudios', audios);
    commit('handleAudioSelect', null);

    fragment.audios = fragment.audios.filter(aid => aid !== id);
  },
  async getMaterialList(
    { commit, state },
    { order = 'id', page = 1, material = '', u_id = '0', material_type = '', classify = 0, category = 0, label = '' }
  ) {
    materialListCounter++;
    const counter = materialListCounter;

    const data = await post('find-material', {
      page, limit: 30, material_type, u_id, order, material, orderby: 'desc', classify, category, label
    }, true);
    if (!data.lists) {
      return;
    }

    if (counter === materialListCounter) {
      const materialList = (page === 1 ? [] : state.materialList).concat(data.lists);
      commit('handleMaterialList', materialList);
      return { lastPage: page * 30 >= data.listsCount };
    }
  },
  async getPresetList({ state, commit }, { type, page = 1, classify = '', name = '' }) {
    presetListCounter++;
    const counter = presetListCounter;
    const data = await get('assembly/lists', {
      type,
      page,
      limit: 60,
      classify,
      name,
      specs: (+type === 1 || +type === 6)
        ? (state.screenRatio > 1 ? 1 : state.screenRatio < 1 ? 3 : 2)
        : undefined
    });
    if (counter === presetListCounter) {
      commit('handlePresets', (page === 1 ? [] : state.presets).concat(data.data));
      return { lastPage: +page >= data.totalPage };
    }
    return false;
  },
  async getLottieCats({ state, commit }, type) {
    const data = await get('lottie/cats', { type });
    console.log('getLottieCats')
    commit('handlePresetsCats', data.length > 0 ? [{ id: "", en_name: "", cn_name: "全部" }, ...data] : data)
  },
  async getAssemblyCats({ state, commit }, type) {
    const data = await get('assembly/category', { type });
    commit('handlePresetsCats', data.length > 0 ? [{ id: "", en_name: "", cn_name: "全部" }, ...data] : data)
  },
  async getHotPublicCats({ state, commit }) {
    const data = await get('material/category-list');
    const list = [{ id: '', cn_name: '全部' }].concat(
      data[1].category_list.map(obj => ({
        ...obj,
        cn_name: obj.name
      }))
    );
    commit('handlePresetsCats', list);
  },
  changeActiveFragment({ commit, state }, changedFragment) {
    commit('handleFragments', state
      .fragments
      .map((frag, i) =>
        i === state.activeFragmentIndex ? changedFragment : frag
      ));
  },
  handleUploadFile: async (context, { files, fn }) => {
    try {
      const res = await uploadFile(files, fn);
      message.success('上传成功');
      return res
    } catch (e) {
      message.error('上传失败');
    }
  },
  processAddEffectItem({ state, getters, commit, dispatch }, effect) {
    const key = effect.id;
    const fragment = getters.activeFragment;

    const duration = effect.duration || Math.min(6e3, fragment.duration);

    const processedEffect = {
      // TODO: effect could have its own duration
      ...effect,
      duration,
      start: clamp(
        state.currentProgress - fragment.start,
        0,
        Math.max(fragment.duration - duration, 0)
      ),
      tracks: [
        {
          id: 1,
          start: 1e3,
          duration: 1e3,
          text: 'animation',
          effectType: 'gradientFade',
          params: {
            direction: 'left'
          }
        }
      ]
    };

    if (state.editingContainer) {
      if (effect.type === 'container') {
        Modal.warning({
          title: 'Cannot add to container.',
          content: 'This feature is not supported.'
        });
      } else {
        const containerEffect = state.effects[state.editingContainer];
        if (!containerEffect) {
          message.error('当前容器已被移除。');
          commit('handleContainerEdit', null);
          return;
        }
        processedEffect.container = state.editingContainer;

        let duration = containerEffect.duration;
        if (processedEffect.type === 'video') {
          duration = clamp(duration, 400, getCropDuration(processedEffect.content));
        }
        commit('handleEffects', {
          ...state.effects,
          [key]: processedEffect,
          [state.editingContainer]: {
            ...containerEffect,
            duration,
            children: [key] // replace children with key.
          }
        });
        commit('handleContainerEdit', null);
        commit('handleEffectSelect', [key]);
      }
      return;
    }

    commit('handleEffects', {
      ...state.effects,
      [key]: processedEffect
    });

    dispatch('changeActiveFragment', {
      ...fragment,
      effects: [
        ...fragment.effects,
        key
      ]
    });

    commit('handleTimelineFilter', '');
    commit('handleVideoSeriesTagMode', false);
    commit('handleEffectSelect', [key]);
  },
  // 添加图片/视频/文本素材函数
  addMaterialItem({ dispatch, state, getters }, {
    name,
    url,
    material_type = '1',
    ratio,
    ownDuration
  }) {
    const type = ['', 'image', 'video'][material_type] || 'image';
    const key = Date.now() + '';
    const usedWidth = Math.min(400 * (ratio || 1.5), state.screenRatio * 480);
    const height = usedWidth / ratio;

    const left = state.editingContainer ? 0 : (state.screenRatio * 480 - usedWidth) / 2;
    const top = state.editingContainer ? 0 : (480 - height) / 2;

    const effect = {
      id: key,
      type,
      locked: false,
      hidden: false,
      content: {
        src: url,
        name,
        top,
        left,
        width: usedWidth,
        height,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        flip: 'none',
        shadow: false,
        shadowX: 1,
        shadowY: 3,
        shadowBlur: 5,
        shadowColor: '#000000',
        radius: 0
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    if (type === 'video') {
      Object.assign(effect.content, {
        loop: false,
        mute: false,
        volume: 100,
        musicVolume: 100,
        playbackRate: 1,
        fadeIn: false,
        fadeInDuration: 1e3,
        fadeOut: false,
        fadeOutDuration: 1e3,
        shakiness:'none'
      });
      effect.duration = Math.min(ownDuration, getters.activeFragment.duration - state.currentProgress + getters.activeFragment.start);
      effect.content.crop = [0, ownDuration / 1e3];
      const { allVideos } = getters;
      if (allVideos.length && allVideos.every(t => t.content.volume === 0)) {
        effect.content.volume = 0;
      }
    } else {
      effect.content.repeat = false;
    }
    dispatch('processAddEffectItem', effect);
  },
  addTextItem({ state, dispatch }) {
    const width = Math.min(state.screenRatio * 480, 400);
    const key = Date.now() + '';
    const left = (state.screenRatio * 480 - width) / 2;

    const effect = {
      id: key,
      type: 'text',
      locked: false,
      hidden: false,
      content: {
        text: 'Text',
        name: '',
        top: 216,
        left,
        width,
        height: 46,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        fontSize: 48 * state.screenHeight / 720, // close enough to the solution
        color: '#333',
        shadow: false,
        shadowX: 1,
        shadowY: 3,
        shadowBlur: 5,
        shadowColor: '#000000',
        align: 'center',
        verticalAlign: 'middle',
        lineHeight: 1.4,
        fontFamily: 'Montserrat-Regular',
        autoFontSize: true,
        gradient: null,
        strokeColor: '#e4c',
        strokeWidth: 0,
        fontAlpha: false,
        flip: 'none',
        letterSpacing: 0
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  addShapeItem({ state, dispatch }, { type, id }) {
    const key = Date.now() + '';
    const isLinear = shapeParams[type] && shapeParams[type].shapeLinear;
    addClickCount(id);
    const effect = {
      id: key,
      type: 'shape',
      locked: false,
      hidden: false,
      content: {
        shape: type,
        top: isLinear ? 239 : 140,
        left: (state.screenRatio * 480 - 200) / 2,
        width: 200,
        height: isLinear ? 2 : 200,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        color: '#e4e4e4',
        shadow: false,
        shadowX: 1,
        shadowY: 3,
        shadowBlur: 5,
        shadowColor: '#000000',
        name: state.shapeNames[type] || '',
        strokeNumeric: true,
        ...(shapeParams[type] || {}),
        flip: 'none'
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  addContainerItem({ state, dispatch }, { type, id }) {
    const key = Date.now() + '';
    addClickCount(id);
    const effect = {
      id: key,
      type: 'container',
      locked: false,
      hidden: false,
      content: {
        shape: type,
        top: 90,
        left: (state.screenRatio * 480 - 300) / 2,
        width: 300,
        height: 300,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        name: state.shapeNames[type] || '',
        ...(shapeParams[type] || {}),
        flip: 'none'
      },
      children: [],
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  addTextContainerItem({ state, dispatch }) {
    const width = Math.min(state.screenRatio * 480, 400);
    const key = Date.now() + '';
    const left = (state.screenRatio * 480 - width) / 2;

    const effect = {
      id: key,
      type: 'textContainer',
      locked: false,
      hidden: false,
      content: {
        text: 'Text',
        name: '',
        top: 195,
        left,
        width,
        height: 90,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        fontSize: 96 * state.screenHeight / 720, // close enough to the solution
        align: 'center',
        verticalAlign: 'middle',
        lineHeight: 1.4,
        fontFamily: 'Montserrat-Bold',
        autoFontSize: true,
        gradient: null,
        flip: 'none',
        letterSpacing: 0
      },
      children: [],
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  addWordArtItem({ state, dispatch }, type) {
    const width = Math.min(state.screenRatio * 480, 400);
    const key = Date.now() + '';
    const left = (state.screenRatio * 480 - width) / 2;

    const effect = {
      id: key,
      type: 'wordArt',
      locked: false,
      hidden: false,
      content: {
        wordArtType: type,
        text: 'Text',
        name: '',
        top: 195,
        left,
        width,
        height: 90,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        fontSize: 96 * state.screenHeight / 720, // close enough to the solution
        align: 'center',
        verticalAlign: 'middle',
        lineHeight: 1.4,
        fontFamily: 'Montserrat-Bold',
        autoFontSize: true,
        gradient: null,
        flip: 'none',
        letterSpacing: 0,
        ...WordArtParams[type]
      },
      children: [],
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  addIconItem({ state, dispatch }, { icon, theme }) {
    const key = Date.now() + '';

    const effect = {
      id: key,
      type: 'icon',
      locked: false,
      hidden: false,
      content: {
        icon,
        theme,
        top: 140,
        left: (state.screenRatio * 480 - 200) / 2,
        width: 200,
        height: 200,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        color: '#333',
        secondaryColor: '#e4e4e4',
        shadow: false,
        shadowX: 1,
        shadowY: 3,
        shadowBlur: 5,
        shadowColor: '#000000',
        name: icon,
        flip: 'none'
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    dispatch('processAddEffectItem', effect);
  },
  async addPresetItem({ state, getters, commit, dispatch }, presetId) {
    const effects = {};
    const fragment = getters.activeFragment;
    commit('handleLoading', true);
    addClickCount(presetId);
    const preset = await get('assembly/details', { id: presetId });

    const normalizeEffectScale = (effect, id) => {
      const efc = { ...effect.content };
      const factor = state.screenHeight / (preset.screenHeight || 720); // TODO: other default screen heights
      if (effect.type === 'text') {
        efc.fontSize *= factor;
      }

      return {
        ...effect,
        id,
        content: efc,
        tracks: effect.tracks && effect.tracks.map(track => {
          if (effectParams[track.effectType]) {
            const params = { ...effectParams[track.effectType] };
            if (track.params) {
              Object.keys(track.params).forEach(key => {
                let flag = false;
                switch (key) {
                  case 'distance':
                  case 'mirror_distance':
                    if (+track.params[key]) {
                      flag = true;
                    }
                    break;
                  case 'radius':
                    if (+track.params[key] && track.effectType === 'gaussianBlur') {
                      flag = true;
                    }
                    break;
                }

                if (flag) {
                  params[key] = track.params[key] * factor;
                } else {
                  params[key] = track.params[key];
                }
              });
            }
            return {
              ...track,
              params
            };
          }
          return track;
        })
      };
    };
    const effectKeys = preset.content.map((effect, i) => {
      const id = +new Date() + '-' + i;
      const children = [];
      if (effect.children && effect.children.length) {
        children.push.apply(children, effect.children.map((c, i) => {
          const cid = id + 'c' + i;
          effects[cid] = {
            ...normalizeEffectScale(c, cid),
            container: id
          };
          return cid;
        }));
      }
      // FIXME: scale em.
      const nextEffect = normalizeEffectScale(effect, id);
      if (effect.children) {
        nextEffect.children = children;
      }
      effects[id] = nextEffect;
      return id;
    });

    normalizeEffects(effects);

    commit('handleEffects', {
      ...state.effects,
      ...effects
    });

    dispatch('changeActiveFragment', {
      ...fragment,
      effects: [
        ...fragment.effects,
        ...effectKeys
      ]
    });

    commit('handleTimelineFilter', '');
    commit('handleEffectSelect', [effectKeys[effectKeys.length - 1]]);
    commit('handleLoading', false);
  },
  async addStickerItem({ state, commit, dispatch }, { id, thumbnail: url }) {
    const key = Date.now() + '';
    commit('handleLoading', true);
    addClickCount(id);
    const resp = await getSVGData(url);
    const { source, aspectRatio } = normalizeSVGSource(resp.data);
    commit('handleLoading', false);
    console.log('url',url)
    const effect = {
      id: key,
      type: 'sticker',
      locked: false,
      hidden: false,
      content: {
        name: 'Template Material',
        top: 165,
        left: (state.screenRatio * 480 - 150) / 2,
        width: 150,
        height: 150 / aspectRatio,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        stickerHTML: source,
        flip: 'none',
        src: url
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false,
    };
    dispatch('processAddEffectItem', effect);
  },
  async addLottieItem(
    { state, commit, dispatch },
    { item: { url, id, title, repeat }, type }
  ) {
    const key = Date.now() + '';
    addClickCount(id, true);

    const data = await getLottie(url);
    const width = 200 * data.w / data.h;

    const effect = {
      id: key,
      type: 'lottie',
      locked: false,
      hidden: false,
      isEffect: type === 2,
      content: {
        top: 140,
        left: (state.screenRatio * 480 - width) / 2,
        width,
        height: 200,
        rotate: 0,
        brightness: 1,
        opacity: 100,
        scale: 1,
        src: url,
        loop: type === 2 || repeat,
        name: title || data.nm,
        lottieId: id,
        flip: 'none'
      },
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false
    };
    if (type === 2) {
      Object.assign(
        effect.content,
        fitCanvas(effect.content, state.screenRatio * 480, 480)
      );
    }
    dispatch('processAddEffectItem', effect);
  },
  forceRemoveMaterialItem({ state }, { effectId, clipboard }) {
    const { activeFragmentIndex, fragments, effects } = state;
    // 不要删除 effects 里的元素，如果片段时复制的，会影响关联片段
    // FIXME: this is an array
    // 数字人不能删除
    if (state.isFisher && state.fisherInfo.type === 'digitalHuman' &&effects[effectId].figure) {
      return
    }
    if (clipboard) {
      console.log('already in clipboard');
      state.clipboardType = 'cut';
    } else {
      delete effects[effectId];
    }
    const fragment = fragments[activeFragmentIndex];
    fragment.effects = fragment.effects.filter(item => '' + item !== '' + effectId);
  },
  processRemoveMaterialItem({ state, dispatch }, effectId) {
    const { effects, clipboard } = state;
    const clipboardLookup = {};
    const effect = effects[effectId];
    const children = effect && effect.children;
    const container = effect && effect.container && effects[effect.container];

    if (clipboard) {
      clipboard.forEach(c => {
        clipboardLookup[c] = true;
        if (effects[c] && effects[c].children) {
          effects[c].children.forEach(cc => {
            clipboardLookup[cc] = true;
          });
        }
      });
    }
    try {
      dispatch('forceRemoveMaterialItem', {
        effectId,
        clipboard: clipboardLookup[effectId]
      });
      if (container) {
        container.children = container.children.filter(id => '' + id !== '' + effectId);

        if (container.type === 'group') {
          if (container.children.length <= 1) {
            dispatch('processUngroupEffects', { groups: [container] });
          } else {
            dispatch('adjustGroupSize', [container]);
          }
        }
      }
      if (children) {
        children.forEach(c => {
          dispatch('forceRemoveMaterialItem', {
            effectId: c,
            clipboard: clipboardLookup[c]
          });
        });
      }
      dispatch('cleanupLinks');
      return true;
    } catch (e) {
      return false;
    }
  },
  // 删除素材
  async removeMaterialItem({ commit, state, dispatch }) {
    const { selectedEffectIds, effects, clipboard } = state;

    const clipboardLookup = {};
    if (clipboard) {
      clipboard.forEach(c => {
        clipboardLookup[c] = true;
        if (effects[c] && effects[c].children) {
          effects[c].children.forEach(cc => {
            clipboardLookup[cc] = true;
          });
        }
      });
    }

    for (const selectedEffectId of selectedEffectIds) {
      const effect = effects[selectedEffectId];
      let container;
      let children;
      if (effect) {
        if (effect.container) {
          container = effects[effect.container];
        }
        children = effect.children;
      }
      dispatch('forceRemoveMaterialItem', {
        effectId: selectedEffectId,
        clipboard: clipboardLookup[selectedEffectId]
      });
      if (children) {
        children.forEach(c => {
          dispatch('forceRemoveMaterialItem', {
            effectId: c,
            clipboard: clipboardLookup[c]
          });
        });
      }
      if (container) {
        container.children = container.children.filter(c => c !== selectedEffectId);

        if (container.type === 'group') {
          if (container.children.length <= 1) {
            dispatch('processUngroupEffects', { groups: [container] });
          } else {
            dispatch('adjustGroupSize', [container]);
          }
        }
      }
    }
    dispatch('cleanupLinks');
    commit('handleEffectSelect', []);
  },
  cleanupTags({ state, getters }) {
    const effectLookup = {};
    const getEffect = id => state.effects[id];

    const { activeFragment } = getters;
    const { effects } = activeFragment;
    const effectList = [].concat.apply([],
      effects.map(getEffect)
        .map(ef => [ef].concat(ef.children ? ef.children.map(getEffect) : []))
    );
    effectList.forEach(ef => {
      effectLookup[ef.id] = ef; // which occur in this fragment.
    });
    effectList.forEach(ef => {
      const tags = ef.videoSeriesTags;
      const params = ef.videoSeriesTagParams;
      if (tags && params) {
        label: if (params.type === 'material') {
          const linked = effectLookup[params.link];
          if (linked && linked.videoSeriesTags) {
            const types = tags.slice(0, -1);
            if (
              types.length === linked.videoSeriesTags.length
              && types.every((type, i) => type === linked.videoSeriesTags[i])
            ) {
              console.log('matched');
              break label;
            } else {
              const tag = linked.videoSeriesTags.slice(1).reduce((prev, cur) => {
                let ret = null;
                (prev.lower || prev.text).some(x => {
                  if (x.material_label_id === cur) {
                    ret = x;
                    return true;
                  }
                  return false;
                });
                return ret;
              }, state.videoSeriesTagData[linked.videoSeriesTags[0]]);
              if (tag && tag.text && tag.text.length) {
                Vue.set(ef, 'videoSeriesTags', linked.videoSeriesTags.concat(tag.text[0].material_label_id));
                break label;
              }
            }
          }
          // clean up text-material links
          Vue.set(ef, 'videoSeriesTags', null);
          Vue.set(ef, 'videoSeriesTagParams', null);
        }
      }
    });
  },
  cleanupLinks({ state, getters, dispatch }) {
    const getEffect = id => state.effects[id];
    const { userBasics } = state;
    if (userBasics && userBasics.is_open_template) {
      dispatch('cleanupTags');
      const { activeFragment } = getters;
      const { effects } = activeFragment;
      const groupedEffects = {};
      [].concat.apply([],
        effects.map(getEffect)
          .map(ef => [ef].concat(ef.children ? ef.children.map(getEffect) : []))
      ).forEach(ef => {
        if (ef.linkId) {
          if (!(ef.linkId in groupedEffects)) {
            groupedEffects[ef.linkId] = [];
          }
          groupedEffects[ef.linkId].push(ef);
        }
      });

      Object.keys(groupedEffects).forEach(k => {
        const arr = groupedEffects[k];
        if (arr.length === 1) {
          arr[0].linkId = null;
        }
      });
    }
  },
  processBatchRemoveTrack,
  autoMaticprocessBatchRemoveTrack,
  processRemoveTrack,
  removeSelectedTrack,
  replaceBackground({ state, getters }, { url, name, material_type }) {
    if (+material_type !== 1) {
      message.error('只能选择图片类型素材');
      return;
    }
    const { activeFragment } = getters;
    const { effects } = state;
    const backgroundEffect = effects[activeFragment.background];
    backgroundEffect.content = {
      ...backgroundEffect.content,
      src: url,
      name,
    }
  },
  autoRemoveSelection({ state, dispatch }) {
    const {
      selectedEffectIds,
      selectedTrackId,
      selectedAudioId
    } = state;

    if (selectedEffectIds.length) {
      dispatch('removeMaterialItem');
    } else if (selectedTrackId) {
      dispatch('removeSelectedTrack');
    } else if (selectedAudioId) {
      dispatch('removeFragmentAudio');
    }
  },
  replaceMaterialItem(
    { state, commit, dispatch, getters },
    { url, name, material_type = '1', ratio, ownDuration }
  ) {
    const { selectedEffectId } = getters;

    // 如果是替换背景图，进入替换背景图逻辑
    if (selectedEffectId === 'BACKGROUND_SELECT') {
      dispatch('replaceBackground', { url, name, material_type });
      return;
    }

    const type = ['', 'image', 'video'][material_type] || 'image';
    const effect = state.effects[selectedEffectId];
    effect.type = type;
    effect.content = {
      ...effect.content
    };
    if (type === 'video') {
      effect.content = {
        ...effect.content,
        crop: [0, ownDuration / 1e3], // initialize or clear video crop
        loop: false,
        mute: false,
        volume: 100,
        playbackRate: ownDuration < 400 ? ownDuration / 400 : 1,
        musicVolume: 100,
        fadeIn: false,
        fadeInDuration: 1e3,
        fadeOut: false,
        fadeOutDuration: 1e3,
      };
      effect.duration = clamp(ownDuration, 400, effect.duration);

      const container = effect.container;
      if (container) {
        const containerEffect = state.effects[container];
        containerEffect.duration = clamp(containerEffect.duration, 400, effect.duration);
      }
    }

    effect.content.clip = null;
    effect.content.src = url;
    effect.content.name = name;
    effect.content.width = ratio * effect.content.height;
    commit('handleEditStatus', false);
    if (state.isFisher && state.fisherInfo?.type === 'digitalHuman') {
      return
    }
    commit('handleCurrentMenu', 'VideoClipList');
    commit('handleCurrentIcon', 'snippet');
  },
  //输入数值控制选中元素的样式
  handleMaterielItemStyle({ state, getters }, { type, value }) {
    const { effects } = state;
    const { activeFragment, selectedEffectId } = getters;
    const currentEffect =
      effects[selectedEffectId === 'BACKGROUND_SELECT'
        ? activeFragment.background
        : selectedEffectId] || {};
    if (currentEffect) {
      currentEffect.content[type] = value;
    }
  },
  // 输入数值控制出现/持续时间
  handleMaterielItemInfo({ state, getters }, { type, value }) {
    const { effects } = state;
    const { selectedEffectId } = getters;
    const currentEffect = effects[selectedEffectId] || {};
    currentEffect[type] = value
  },
  handleFragmentsDuration({ state, commit }, duration) {
    const { activeFragmentIndex, fragments } = state;
    let after = false;
    let delta = 0;
    commit('handleFragments', fragments.map((frag, i) => {
      if (after) {
        return {
          ...frag,
          start: frag.start + delta
        };
      }
      if (i === activeFragmentIndex) {
        after = true;
        delta = duration - frag.duration;
        return {
          ...frag,
          duration,
          transition: frag.transition ? {
            ...frag.transition,
            start: frag.transition.start + delta
          } : null
        };
      }
      return frag;
    }));
  },
  async addFragment({ state, getters, commit }) {
    const id = Date.now() + '';
    const { fragments } = state;
    let start = 0;
    if (fragments && fragments.length) {
      const frag = fragments[fragments.length - 1];
      start = frag.start + frag.duration - (frag.transition ? frag.transition.duration : 0);
    }
    let insertion = 'end';
    const newFragment = {
      id,
      name: 'Frag' + id,
      start,
      duration: 3000,
      tracks: [],
      effects: [],
      background: null,
      transition: null,
      backgroundColor: '#fff',
      hideStamp: false,
      audios: []
    };
    const result = await generatePositionModal({
      title: '选择片段新增位置。',
      options: [
        {
          value: 'before',
          label: '当前片段之前'
        },
        {
          value: 'current',
          label: '当前片段之后'
        },
        {
          value: 'end',
          label: '最后一个片段之后'
        }
      ],
      defaultValue: 'current',
      done(value) {
        insertion = value;
      }
    });
    if (!result) {
      return;
    }
    console.log(newFragment);
    switch (insertion) {
      case 'end':
        fragments.push(newFragment);
        break;
      case 'before':
        {
          const { start = 0 } = getters.activeFragment;
          newFragment.start = start;
          const fragmentsBefore = fragments.slice(0, state.activeFragmentIndex);
          const fragmentsAfter = fragments.slice(state.activeFragmentIndex).map(frag => ({
            ...frag,
            start: frag.start + newFragment.duration
          }));
          state.fragments = fragmentsBefore.concat(newFragment, fragmentsAfter);
          break;
        }
      default: {
        const { start = 0, duration = 0, transition } = getters.activeFragment;
        newFragment.start = start + duration - (transition ? transition.duration : 0);
        const fragmentsBefore = fragments.slice(0, state.activeFragmentIndex + 1);
        const fragmentsAfter = fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
          ...frag,
          start: frag.start + newFragment.duration
        }));
        state.fragments = fragmentsBefore.concat(newFragment, fragmentsAfter);
        break;
      }
    }
    commit('handleShowSubVideoClipList', false);
  },
  removeFragment({ state, commit }, index) {
    const { activeFragmentIndex, fragments } = state;
    const activeIndex = index || activeFragmentIndex;
    const { duration, transition } = fragments[activeIndex];

    // 在选中片之后，将所有片段的开始时间往前移一格
    fragments.forEach((item, index) => {
      if (index > activeIndex) {
        item.start = item.start - duration + (transition ? transition.duration : 0);
      }
    });

    // TODO: remove corresponding effects except for the one(s) that may exist in clipboard

    // 删除当前选中的片段
    fragments.splice(activeIndex, 1);
    commit('handleActiveFragmentIndex', 0);
  },
  reorderFragment({ state, commit }) {
    const { activeFragmentIndex, fragments, nextFragmentOrder } = state;
    const activeFragment = fragments[activeFragmentIndex];
    const { duration, transition } = activeFragment;
    const shift = duration - (transition ? transition.duration : 0);
    const up = activeFragmentIndex > nextFragmentOrder;
    let curStart = 0;
    if (
      nextFragmentOrder !== null
      && nextFragmentOrder !== activeFragmentIndex
      && activeFragmentIndex !== nextFragmentOrder - 1
    ) {
      const nextFragmentList = fragments.map((item, i) => {
        if (up) {
          if (i < activeFragmentIndex && i >= nextFragmentOrder) {
            // move others down
            item.start = item.start + shift;
          }
        } else if (i > activeFragmentIndex && i < nextFragmentOrder) {
          // move others up
          item.start = item.start - shift;
        }

        if (i === activeFragmentIndex) {
          return [];
        }
        if (i === nextFragmentOrder) {
          return [activeFragment, item];
        }
        return item;
      });

      if (fragments[nextFragmentOrder - 1]) {
        const { start: prevStart, duration: prevDuration, transition: prevTransition } = fragments[nextFragmentOrder - 1];
        curStart = prevStart + prevDuration - (prevTransition ? prevTransition.duration : 0);
      }
      activeFragment.start = curStart;

      commit(
        'handleFragments',
        [].concat.apply([], nextFragmentList.concat(nextFragmentOrder === fragments.length ? activeFragment : []))
      );
      commit('handleCurrentProgress', activeFragment.start);
      commit('handleActiveFragmentIndex', up ? nextFragmentOrder : nextFragmentOrder - 1);
    }
    commit('handleFragmentReorder', false);
    commit('handleNextFragmentOrder', null);
  },
  copyFragment({ state, commit }, checkIndex) {
    const { activeFragmentIndex, fragments, effects, audios } = state;
    const activeIndex = checkIndex != undefined ? checkIndex : activeFragmentIndex;

    let fragment = fragments[activeIndex]
    const id = Date.now() + '';
    const { effects: fragmentEffects, audios: fragmentAudios } = fragment;
    let newFragmentEffects
    if (checkIndex) { // 复选可能重复，故加上复制的下标
      newFragmentEffects = fragmentEffects.map((_, index) => Date.now() + index + '' + checkIndex);
    } else {
      newFragmentEffects = fragmentEffects.map((_, index) => Date.now() + index + '');
    }

    let backgroundEffectId;

    if (fragment.background) {
      backgroundEffectId = Date.now() + fragmentEffects.length + '';
    }

    const effectIdList = newFragmentEffects.concat(backgroundEffectId || []);

    const nextAudios = { ...audios };

    // 复制当前素材
    // 备注：要以非可变的方式改变数据，保证刷新
    // copy child effects and container effects
    const newEffects = fragmentEffects.concat(fragment.background || []).reduce((pre, cur, index) => {
      const curEffectId = effectIdList[index];
      const effect = { ...effects[cur], id: curEffectId + '' };
      const childEffects = {};
      if (effect.children) {
        let children = effect.children.map((c, i) => {
          const childEffectId = [curEffectId, i].join('c');
          childEffects[childEffectId] = {
            ...effects[c],
            id: childEffectId,
            container: curEffectId
          };
          return childEffectId;
        });

        effect.children = children;
      }
      return {
        ...pre,
        ...childEffects,
        [curEffectId]: effect
      }
    }, effects);

    // 深拷贝一次，剔除所有关联
    commit('handleEffects', JSON.parse(JSON.stringify(newEffects)));

    const nextAudioIds = fragmentAudios.map((id, index) => {
      const nextId = +new Date + '' + index;
      nextAudios[nextId] = JSON.parse(JSON.stringify({
        ...audios[id],
        id: nextId
      }));

      return nextId;
    });

    commit('handleAudios', nextAudios);

    // 复制当前字幕列表
    // const newTracks = tracks.map((item, index) => ({
    //   ...item,
    //   id: Date.now() + index + ''
    // }));
    // 取出当前片段持续时间
    const { duration, start, transition } = fragment;
    const offset = duration - (transition ? transition.duration : 0);

    // 少于当前索引，直接返回
    // 等于当前索引，复制一份放在被复制的后面
    // 大于当前索引，开始时间往后移动一格
    const newFragments = fragments.reduce((pre, cur, index) => {
      if (index < activeIndex) {
        return [...pre, cur]
      } else if (index === activeIndex) {
        return [
          ...pre,
          cur,
          {
            ...cur,
            id,
            name: 'Frag' + id,
            start: start + offset, // 接在被复制面片的后面
            effects: newFragmentEffects,
            // tracks: newTracks,
            background: backgroundEffectId || null,
            audios: nextAudioIds
          }]
      } else {
        return [...pre, { ...cur, start: cur.start + offset }]
      }
    }, []);
    commit('handleFragments', newFragments);
  },
  setBackground({ getters, dispatch }) {
    const activeFragment = getters.activeFragment;
    const currentEffect = getters.currentEffect;

    if (activeFragment.background) {
      message.warn('背景图已存在');
    } else {
      activeFragment.effects = activeFragment.effects.filter(ef => ef !== currentEffect.id);
      activeFragment.background = currentEffect.id;
      activeFragment.backgroundType = currentEffect.type;
    }
    dispatch('selectBackground');
  },
  selectBackground({ commit }) {
    commit('handleEffectSelect', ['BACKGROUND_SELECT']);
  },
  unsetBackground({ getters, commit }) {
    const activeFragment = getters.activeFragment;

    if (activeFragment.background) {
      const id = activeFragment.background;
      activeFragment.background = null;
      activeFragment.backgroundType = null;
      activeFragment.effects.push(id);
      commit('handleTimelineFilter', '');
      commit('handleEffectSelect', [id]);
    }
  },
  setEditStatus({ commit }, value) {
    commit('handleEditStatus', value);
    if (value) {
      commit('handleCurrentIcon', 'material');
      commit('handleCurrentMenu', 'MaterialMenu');
    }
  },
  addSubtitleTrack,
  loadLanguages,
  textToAudio,
  processLoadTranslations,
  loadTranslations,
  async loadFontList({ commit }) {
    await getToken();

    const list = await post('manage/template-font-list');
    const fontLookup = {};
    const fontStates = {};
    const styleString = list.map(item => {
      fontLookup[item.font_name] = item.font_alias;
      fontStates[item.font_name] = '';
      return `@font-face{font-family:${item.font_name};src:local('${item.font_name}'),url('/assets/fonts/${item.font_alias}')}`
    }).join('');
    commit('handleFontList', list);
    commit('handleFontNameLookup', fontLookup);
    commit('handleFontStates', fontStates);
    const head = document.querySelector('head');
    const style = document.createElement('style');
    style.innerHTML = styleString;
    head.appendChild(style);
  },
  getSeoTitle,
  clearSeoSearch,
  async loadDraftData(
    { state, getters, commit, dispatch },
    { id, draftId, templateId, type, params, backup }
  ) {
    commit('handleLoading', true);
    commit('handleRecordDisabled', true);
    await getToken();
    let promise;
    if (templateId) {
      if (params && (+params.type < 6)) {
        promise = post('listrule', { id: templateId }).then(async (res) => {
          const { rule = [], resolution = '1280*720', name: videoName = '' } = res;
          const usedResolution = resolution.split('*').map(r => +r);
          const screenRatio = usedResolution[0] / usedResolution[1],
            fragments = [],
            effects = {},
            screenHeight = usedResolution[1];
          console.log(res);

          let start = 0;
          let duration = 0;
          const aspectRatio = screenHeight / state.previewScreenHeight;

          const transformedRules = await Promise.all(
            [].concat(rule).map((r, i) => effectsTransformer(r, aspectRatio, screenRatio, screenHeight, resolution, 'seed' + i))
          );
          transformedRules.forEach(({
            values: newEffects,
            keys: newFragmentEffects
          }, i) => {
            const fragRule = rule[i];
            const newFragment = fragmentsTransformer(rule, start + duration, fragRule.duration / 1e3);
            start = newFragment.start;
            duration = fragRule.duration;
            const nextRule = rule[i + 1];
            if (nextRule && nextRule.transitionArray) {
              console.log('transition is enabled');
              newFragment.transition = {
                name: nextRule.transitionArray.type,
                duration: 1e3,
                start: newFragment.duration - 1e3
              };
              start -= 1e3;
            }
            Object.assign(effects, newEffects);
            fragments.push({
              ...newFragment,
              effects: newFragmentEffects,
              hideStamp: false,
              id: +new Date() + i + ''
            });
          });

          const {
            myVideoMusic,
            musicStartEnd,
            musicVolume,
            setupMusic,
            stampEnabled,
            stamp,
            ttsRule,
            translationEnabled,
            selectedLanguages,
            useTTSLanguages
          } = state;

          return {
            params: {
              screenRatio,
              fragments,
              videoName,
              effects,
              screenHeight,
              myVideoMusic,
              musicStartEnd,
              musicVolume,
              setupMusic,
              stampEnabled,
              stamp,
              ttsRule,
              translationEnabled,
              selectedLanguages,
              useTTSLanguages,
              audios: {}
            },
            name: videoName
          };
        });
      } else {
        promise = post('template/draft', { id: templateId });
      }
    } else if (backup) {
      // ...
      promise = get('video/get_backup').then(data => {
        return {
          ...data,
          params: JSON.parse(data.params)
        };
      });
    } else {
      let effects = state.effects
      Object.keys(effects).map(a=>{
        if(effects[a].shakinessId){
          delete effects[a].shakinessId;
        }
      })
      commit('handleEffects', {...effects})
      promise = post(
        'videolog',
        id ? { v_id: id } : { draft_id: draftId }
      );
    }
    const {
      params: editorData,
      v_id,
      name: templateName,
      video_name,
      ttsVideo,
      translated,
      t_scriptid,
      track_id: trackId
    } = await promise
    if (trackId) {
      state.trackId = trackId
    }
    console.log('track_id', state.trackId)
    console.log('获取数据');
    console.log(editorData);
    // editorData.screenHeight / 480
    for(const key in editorData.effects) {
      const effect = editorData.effects[key]
      console.log('effect', editorData.effects[key]);

      if(effect.type == 'video' && effect?.content?.adaptSize) {
        const {left,top,width,height} = effect.content
        console.log(left,top,width,height);
        const [errVideoInfo, videoInfo] = await getVideoInfo(effect?.content?.src)
        console.log(errVideoInfo, videoInfo);
        if (!errVideoInfo) {
          const adjustVideoPosition = (containerWidth, containerHeight, containerLeft, containerTop, videoWidth, videoHeight) => {
            // 计算容器的宽高比
            const containerAspectRatio = containerWidth / containerHeight;

            // 计算视频的宽高比
            const videoAspectRatio = videoWidth / videoHeight;
            // 判断视频的宽高比和容器的宽高比哪个更大
            if (videoAspectRatio > containerAspectRatio) {
              // 如果视频的宽高比大于容器的宽高比，那么视频的高度会过大，需要减小视频的高度
              const newVideoHeight = containerWidth / videoAspectRatio;
              const newVideoTop = (containerHeight - newVideoHeight) / 2 + containerTop;
              return { left: containerLeft, top: newVideoTop, width: containerWidth, height: newVideoHeight };
            } else {
              // 如果视频的宽高比小于容器的宽高比，那么视频的宽度会过小，需要增加视频的宽度
              const newVideoWidth = containerHeight * videoAspectRatio;
              const newVideoLeft = (containerWidth - newVideoWidth) / 2 + containerLeft;
              return { left: newVideoLeft, top: containerTop, width: newVideoWidth, height: containerHeight };
            }
          }
          const position = adjustVideoPosition(width,height,left,top,videoInfo.width,videoInfo.height)
          console.log('adjustVideoPosition',position);
          effect.content.left = position.left
          effect.content.width = position.width
          effect.content.height = position.height
          effect.content.top = position.top
        }

      }
      if (effect.type === 'text' && effect?.content?.autoFontSize) {
        const fontSize = await adjustSize(
          effect.content,
          editorData.screenHeight / 480,
          effect.type === "text" || effect.type === "textContainer"
        );
        effect.content.fontSize = fontSize
      }

    }

    console.log('草稿')
    if(editorData.recordIndex) {
      commit('record/setRecordIndex',editorData.recordIndex)
    }
    console.info('草稿数据')
    const {
      screenRatio,
      fragments,
      videoName,
      effects,
      screenHeight,
      myVideoMusic,
      musicStartEnd,
      musicVolume,
      myVideoMusicVolume,
      setupMusic,
      stampEnabled,
      stamp,
      ttsRule,
      translationEnabled,
      selectedLanguages,
      languageSex,
      useTTSLanguages,
      audios,
      subtitleTracks = {},
      musicFade,
      usedVideoScriptId,
      languageOptions = {},
      useCustomTTS,
      customTTS,
      customTTSIds,
      translationLocked, // is used for customTTS
      descKeywords
    } = editorData;

    normalizeFragments(fragments);
    normalizeEffects(effects, myVideoMusicVolume);

    if (typeof ttsRule.musicVolume === 'undefined') {
      ttsRule.musicVolume = 100;
    }
    if (typeof ttsRule.volume === 'undefined') {
      ttsRule.volume = 100;
    }
    if (typeof ttsRule.useShadow === 'undefined') {
      ttsRule.useShadow = false;
    }

    if (typeof ttsRule.marginV === 'undefined') {
      ttsRule.marginV = marginFactors[screenHeight][0];
    }

    if (type === 'template') {
      commit('handleTemplateId', templateId);
      message.info('进入模板编辑模式');
    } else if (id) { // TODO: handle video creation from template
      commit('handleID', id);
    } else {
      if (v_id) {
        commit('handleID', v_id);
      }
      if (draftId) {
        commit('handleDraftId', draftId);
      }
      if (templateId) {
        commit('handleTemplateUse', templateId);
      }
    }

    if (fragments) {
      fragments.forEach(frag => {
        if (typeof frag.hideStamp === 'undefined') {
          frag.hideStamp = false;
        }

        if (typeof frag.audios === 'undefined') {
          frag.audios = [];
        }
      });
    }

    let actualSelectedLanguages = [];
    if (ttsVideo) {
      await dispatch('loadLanguages');
      const origTexts = {};
      switch (translated) {
        case 3: {
          let translationError = false;
          const usedTTS = ttsVideo[0];
          const lang = getters.reverseLanguageLookup[usedTTS.language];
          actualSelectedLanguages = [lang];
          // TODO: map subtitles to translated text
          const translationLookup = {};
          usedTTS.entry.forEach(item => {
            if (item.txt) {
              translationLookup[item.original_txt.join('\n')] = item.txt.join('\n');
            } else if (item.original_txt) {
              translationError = true;
            }
          });
          Object.keys(subtitleTracks).forEach(k => {
            const st = subtitleTracks[k];
            origTexts[k] = st.text;
            st.text = translationLookup[st.text] || st.text;
          });
          if (translationError) {
            message.error('视频字幕翻译出现错误，将显示原始字幕。');
          } else {
            commit('handleTranslationLock', true);
            commit('handleTranslationGenerate', true);
            commit('handlePreviewLanguageSelect', lang);
          }
          break;
        }
        case 2:
          console.log('handleTranslationGenerate',true);
          commit('handleTranslationGenerate', true);
        // fall through
        default:
          actualSelectedLanguages = ttsVideo.slice(1)
            .map(item => getters.reverseLanguageLookup[item.language]);
      }
      // TODO: subtitle metadata by language
      const langOptions = {};
      await Promise.all(ttsVideo.map(async (tts) => {
        if (tts.language_name && tts.language_name['FEMALE']) {
          langOptions[tts.language_name['FEMALE'] + '-' + tts.sex] = languageOptions[tts.language_name['FEMALE'] + '-' + tts.sex] || {};
          const srcLookup = {};
          await Promise.all(tts.entry.map(async (item) => {
            if (item.src) {
              const text = item.txt.join('\n');
              const duration = await getAudioDuration(item.src);
              srcLookup[item.original_txt.join('\n')] = {
                url: item.src,
                duration: duration * 1e3,
                start: 0,
                text
              };
            }
          }));

          Object.keys(subtitleTracks).forEach(k => {
            const st = subtitleTracks[k];
            const info = srcLookup[origTexts[k] || st.text];
            if (langOptions[tts.language_name['FEMALE'] + '-' + tts.sex][k]) {
              const cur = langOptions[tts.language_name['FEMALE'] + '-' + tts.sex][k];
              if (cur.start + cur.duration > st.duration) {
                cur.duration = Math.min(cur.duration, st.duration);
                cur.start = st.duration - cur.duration;
              }
            } else if (info) {
              const { duration } = info;
              langOptions[tts.language_name['FEMALE'] + '-' + tts.sex][k] = {
                ...info,
                origDuration: duration,
                duration: Math.min(duration, st.duration)
              };
            }
          });
        }
      }));

      Object.assign(languageOptions, langOptions);
    } else {
      actualSelectedLanguages = selectedLanguages;
    }

    if (typeof stamp.offset === 'undefined') {
      stamp.offset = stampPadding({ screenRatio, screenHeight });
    }
    commit('handleLanguageSex', languageSex || 'FEMALE');
    commit('handleEffects', effects);
    commit('handleFragments', fragments);
    commit('handleTTSRule', ttsRule);
    commit('handleScreenRatio', screenRatio);
    commit('handleScreenHeight', screenHeight);
    commit('handleVideoName', (templateId ? templateName : video_name) || videoName);
    commit('handleCurrentMusic', myVideoMusic);
    commit('handleMusicStartEnd', musicStartEnd);
    commit('handleMusicVolume', musicVolume || 1);
    commit('handleMyVideoMusic', myVideoMusic);
    commit('handleSetupMusic', setupMusic);
    commit('handleStampEnabled', stampEnabled);
    // commit('handleStampUrl', [stamp.url, stamp.aspectRatio]);
    state.stamp = stamp;
    commit('handleTranslationEnabled', translationEnabled);
    commit('handleLanguageSelect', actualSelectedLanguages);
    commit('handleUseTTSLanguages', useTTSLanguages);
    commit('handleSubtitleTracks', subtitleTracks);
    if (translated !== 3 || translationLocked) {
      if (typeof useCustomTTS !== 'undefined') {
        commit('handleCustomTTSUse', useCustomTTS);
      }
      if (customTTS) {
        Object.keys(customTTS).forEach(id => {
          const tts = customTTS[id];
          if (typeof tts.volume === 'undefined') {
            tts.volume = 100;
          }
        });
        commit('handleCustomTTS', customTTS);
      }
      if (customTTSIds) {
        commit('handleCustomTTSIds', customTTSIds);
      }
    }
    commit('handleLoading', false);
    if (audios) {
      normalizeAudios(audios);
      commit('handleAudios', audios);
    }
    if (descKeywords) {
      descKeywords.desc = descKeywords.desc || '';
      descKeywords.keywords = descKeywords.keywords || '';
      commit('handleDescKeywords', descKeywords);
    }
    if (musicFade) {
      commit(
        'handleMusicFade',
        Object.assign({ loop: true, delay: 0 }, musicFade)
      );
    }
    const curVideoScriptId = usedVideoScriptId || +t_scriptid;
    if (curVideoScriptId) {
      commit('handleVideoScriptUse', curVideoScriptId);
    }
    if (languageOptions) {
      state.languageOptions = languageOptions;
    }
    dispatch('initUndoStack');
    setTimeout(() => {
      commit('handleRecordDisabled', false);
    }, 0);
  },
  setScreenHeight({ state, commit }, value) {
    const prevHeight = state.screenHeight;
    const factor = value / prevHeight;
    Object.keys(state.effects).forEach(k => {
      const effect = state.effects[k];
      if (effect.type === 'text') {
        effect.content.fontSize *= factor;
      }
    });

    if (marginFactors[value] && marginFactors[prevHeight]) {
      commit('handleTTSRule', {
        ...state.ttsRule,
        marginV: Math.round(state.ttsRule.marginV * marginFactors[value][0] / marginFactors[prevHeight][0])
      });
    }

    commit('handleScreenHeight', value);
  },
  async getTemplateList({ state, commit }, { keyword, type, fragmentType }) {
    ++fragTemplateCounter;
    let counter = fragTemplateCounter;
    commit('handleTemplateList', []);

    // 目前只有一个片段模板，暂时不用做翻页逻辑
    const { screenRatio } = state;
    const specs = screenRatio > 1 ? 1 : screenRatio === 1 ? 2 : 3;
    const templateList = await post('singletemplate', { page: 1, size: 100, specs, name: keyword, type, t_firid: fragmentType });

    if (counter === fragTemplateCounter) {
      console.log(keyword);
      console.log(type);
      commit('handleTemplateList', templateList);
      return true;
    }
    console.log('response was returned to an outdated request.');
    return false;
  },
  async getTemplateSceneIndustryList({ commit }) {
    const list = await post('template', {});
    // 改成折叠面板，不需要有默认选项 2020.12.07 待删
    // const sceneList = [{ value: '', name: '全部场景' }];
    // const industryList = [{ value: '', name: '全部行业' }];
    // const styleList = [{ value: '', name: '全部风格' }];
    // const mediaList = [{ value: '', name: '全部平台' }];
    const sceneList = [];
    const industryList = [];
    const styleList = [];
    const mediaList = [];
    const fragmentTypeList = [];
    list.forEach(item => {
      const obj = { value: '' + item.id, name: item.name };
      switch (item.type) {
        case 1:
          sceneList.push(obj);
          break;
        case 2:
          industryList.push(obj);
          break;
        case 3:
          styleList.push(obj);
          break;
        case 5:
          fragmentTypeList.push(obj);
          break;
        case 999:
          mediaList.push(obj);
          break;
      }
    });
    commit('handleTemplateSceneList', sceneList);
    commit('handleTemplateIndustryList', industryList);
    commit('handleTemplateStyleList', styleList);
    commit('handleTemplateMediaList', mediaList);

    commit('handleFragmentTypeList', fragmentTypeList);
  },
  async getVideoTemplateList({ state, commit }, { keyword, tab, page = 1, scene, industry, style, media }) {
    ++videoTemplateCounter;
    let counter = videoTemplateCounter;

    // 目前只有一个片段模板，暂时不用做翻页逻辑 TODO: pagination
    const { screenRatio } = state;
    const specs = screenRatio > 1 ? 1 : screenRatio === 1 ? 2 : 3;
    let templateList;
    let last = false;
    switch (tab) {
      case 'mine':
        templateList = await post(
          'template/mytemplate',
          { page, size: 20, name: keyword, specs },
          false,
          res => {
            last = res.data.totalPage <= page;
            console.log(res);
          });
        break;
      default:
        templateList = await post(
          'singletemplate',
          { page, size: 20, specs, name: keyword, type: [5, 6], t_firid: scene, t_secid: industry, t_thirdid: style, t_media: media },
          false,
          res => {
            last = res.data.totalPage <= page;
            console.log(res);
          });
    }

    if (counter === videoTemplateCounter) {
      commit('handleVideoTemplateList', (page === 1 ? [] : state.videoTemplateList).concat(templateList));
      return { last };
    }
    return false;
  },
  async getTemplateDetail({ commit, state, getters }, { id, type, toSnippet }) {
    const { fragments, effects, screenRatio, screenHeight } = state;
    const { aspectRatio } = getters;
    let insertion = 'end';
    if (state.showSubVideoClipList === 'replace') {
      const result = await new Promise(resolve => {
        Modal.confirm({
          title: '当前处于片段更换模式',
          content: '替换该片段，将会覆盖当前片段所有内容。',
          icon: 'warning',
          onOk() {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          }
        });
      });
      if (!result) {
        return;
      }
    } else if (type === 4 || type === 7) {
      const result = await generatePositionModal({
        title: '选择作为片头或片尾。',
        options: [
          {
            value: 'start',
            label: '片头'
          },
          {
            value: 'end',
            label: '片尾'
          }
        ],
        defaultValue: 'start',
        done(value) {
          insertion = value;
        }
      });
      if (!result) {
        return;
      }
    } else {
      const result = await generatePositionModal({
        title: '选择片段新增位置。',
        options: [
          {
            value: 'before',
            label: '当前片段之前'
          },
          {
            value: 'current',
            label: '当前片段之后'
          },
          {
            value: 'end',
            label: '最后一个片段之后'
          }
        ],
        defaultValue: 'current',
        done(value) {
          insertion = value;
        }
      });
      if (!result) {
        return;
      }
    }
    commit('handleLoading', true);
    try {
      const hideStamp = type === 4 || type === 7;
      let commitEffects;
      let commitFragments;
      let commitAudios;
      if (type < 6) { // 旧接口
        let res = await post('listrule', { id });
        const { rule = {}, duration: fragmentDuration, resolution = '1280*720' } = res;
        const {
          values: newEffects,
          keys: newFragmentEffects
        } = await effectsTransformer(rule, aspectRatio, screenRatio, screenHeight, resolution);
        normalizeEffects(newEffects);
        let newFragment;
        let fragmentsBefore = [];
        let fragmentsAfter = [];
        if (state.showSubVideoClipList === 'replace') {
          const { start = 0, duration = 0, transition } = getters.activeFragment;
          newFragment = fragmentsTransformer(rule, start, fragmentDuration);
          newFragment = {
            ...newFragment,
            effects: newFragmentEffects,
            transition: transition
              ? { ...transition, start: newFragment.duration - transition.duration }
              : null,
            hideStamp
          };
          fragmentsBefore = fragments.slice(0, state.activeFragmentIndex);
          fragmentsAfter = fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
            ...frag,
            start: frag.start - duration + newFragment.duration
          }));
        } else {
          switch (insertion) {
            case 'end': {
              const lastFrag = fragments.slice(-1)[0];
              const { start = 0, duration = 0 } = lastFrag;
              lastFrag.transition = null;
              newFragment = {
                ...fragmentsTransformer(rule, start + duration, fragmentDuration),
                effects: newFragmentEffects,
                hideStamp
              };
              fragmentsBefore = fragments;
              break;
            }
            case 'current': {
              const { start = 0, duration = 0, transition } = getters.activeFragment;
              newFragment = fragmentsTransformer(
                rule,
                start + duration - (transition ? transition.duration : 0),
                fragmentDuration
              );
              newFragment = {
                ...newFragment,
                effects: newFragmentEffects,
                transition: null,
                hideStamp
              };
              fragmentsBefore = fragments.slice(0, state.activeFragmentIndex + 1);
              fragmentsAfter = fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
                ...frag,
                start: frag.start + newFragment.duration
              }));
              break;
            }
            case 'before': {
              const { start = 0 } = getters.activeFragment;
              // TODO:
              newFragment = {
                ...fragmentsTransformer(
                  rule,
                  start,
                  fragmentDuration
                ),
                effects: newFragmentEffects,
                transition: null,
                hideStamp
              };
              fragmentsBefore = fragments.slice(0, state.activeFragmentIndex);
              fragmentsAfter = fragments.slice(state.activeFragmentIndex).map(frag => ({
                ...frag,
                start: frag.start + newFragment.duration
              }));
              // message.error('Unsupported Insertion Position.');
              break;
            }
            default: {
              newFragment = {
                ...fragmentsTransformer(rule, 0, fragmentDuration),
                effects: newFragmentEffects,
                hideStamp
              };
              fragmentsAfter = fragments.map(frag => ({
                ...frag,
                start: +frag.start + newFragment.duration
              }));
              break;
            }
          }
        }
        commitEffects = { ...effects, ...newEffects };
        commitFragments = fragmentsBefore.concat(newFragment, fragmentsAfter);
      } else { // 新接口 where there can be fragment audios
        let res = await post('template/draft', { id });
        const editorData = res.params;

        const {
          fragments: templateFragments,
          effects: templateEffects,
          audios,
          screenHeight
        } = editorData;

        let fragmentsBefore = [];
        let fragmentsAfter = [];
        let newFragment = templateFragments[0];
        if (state.showSubVideoClipList === 'replace') {
          const { start, duration = 0, transition } = getters.activeFragment;
          newFragment = {
            ...newFragment,
            start,
            transition: transition
              ? { ...transition, start: newFragment.duration - transition.duration }
              : null,
            hideStamp
          };
          fragmentsBefore = fragments.slice(0, state.activeFragmentIndex);
          fragmentsAfter = fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
            ...frag,
            start: frag.start - duration + templateFragments[0].duration
          }));
        } else {
          switch (insertion) {
            case 'end': {
              const lastFrag = fragments.slice(-1)[0];
              const { start = 0, duration = 0 } = lastFrag;
              lastFrag.transition = null;
              newFragment = {
                ...newFragment,
                start: start + duration,
                hideStamp
              };
              fragmentsBefore = fragments;
              break;
            }
            case 'current': {
              const { duration = 0, start, transition } = getters.activeFragment;
              newFragment = {
                ...newFragment,
                start: start + duration - (transition ? transition.duration : 0),
                hideStamp
              };
              fragmentsBefore = fragments.slice(0, state.activeFragmentIndex + 1);
              fragmentsAfter = fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
                ...frag,
                start: +frag.start + templateFragments[0].duration
              }));
              break;
            }
            case 'before': {
              const { start } = getters.activeFragment;
              newFragment = {
                ...newFragment,
                start,
                hideStamp
              };
              const { duration, transition } = newFragment;
              fragmentsBefore = fragments.slice(0, state.activeFragmentIndex);
              fragmentsAfter = fragments.slice(state.activeFragmentIndex).map(frag => ({
                ...frag,
                start: +frag.start + duration - (transition ? transition.duration : 0)
              }));
              break;
            }
            default: {
              newFragment = {
                ...newFragment,
                start: 0,
                hideStamp
              };
              fragmentsAfter = fragments.map(frag => ({
                ...frag,
                start: +frag.start + templateFragments[0].duration
              }));
              break;
            }
          }
        }
        const nextEffects = {};
        let nextEffectId = +new Date();

        const loopEffectId = id => {
          const effect = templateEffects[id];
          if (effect.type === 'text') {
            effect.content.fontSize *= state.screenHeight / screenHeight;
          }
          if (effect.children) {
            effect.children = effect.children.map(loopEffectId);
          }
          if (id in effects) {
            nextEffectId++;
            effect.id = '' + nextEffectId;
          }
          nextEffects[effect.id] = effect;
          return effect.id;
        };

        newFragment.effects = newFragment.effects.map(loopEffectId);

        const nextAudios = {};
        if (newFragment.audios) {
          newFragment.audios = newFragment.audios.map(id => {
            const audio = audios[id];
            if (id in state.audios) {
              nextEffectId++;
              audio.id = 'audio' + nextEffectId;
            }
            nextAudios[audio.id] = audio;
            return audio.id;
          });
        } else { newFragment.audios = []; }
        normalizeEffects(nextEffects);
        normalizeAudios(nextAudios);
        commitEffects = { ...effects, ...nextEffects };
        commitAudios = { ...state.audios, ...nextAudios };
        commitFragments = fragmentsBefore.concat(newFragment, fragmentsAfter);
      }
      commit('handleEffects', commitEffects);
      commit('handleFragments', commitFragments);
      if (commitAudios) {
        commit('handleAudios', commitAudios);
      }
      if (toSnippet) {
        commit('handleCurrentIcon', 'snippet');
        commit('handleCurrentMenu', 'VideoClipList');
      }
    } catch (e) {
      message.error('加载模板失败: ' + e);
    }
    commit('handleLoading', false);
    commit('handleShowSubVideoClipList', false);
  },
  selectMultipleEffects({ state, commit }, effectIds) {
    if (effectIds.length <= 1) {
      commit('handleEffectSelect', effectIds);
    } else {
      const lookup = {};
      const { effects } = state;
      effectIds.forEach(id => {
        if (effects[id] && !effects[id].locked && !effects[id].hidden && !effects[id].container) {
          lookup[id] = true;
        }
      });
      commit('handleEffectSelect', Object.keys(lookup));
    }
  },
  setTimelineFilter({ state, commit }, value) {
    const { selectedEffectIds, effects } = state;
    commit('handleEffectSelect', selectedEffectIds.filter(id => matchFilter(effects[id], value, state.shapeNames)));
    commit('handleVideoSeriesTagMode', false);
    commit('handleTimelineFilter', value);
  },
  toggleVideoSeriesTagMode({ state, commit }) {
    const { selectedEffectIds, effects, timelineFilter, videoSeriesTagMode } = state;
    const value = !videoSeriesTagMode;
    commit('handleEffectSelect', selectedEffectIds.filter(id => matchFilter(effects[id], timelineFilter, state.shapeNames, value)));
    commit('handleVideoSeriesTagMode', value);
  },
  markIntersecting({ state, getters, commit }, area) {
    commit('handleSelectionArea', area);
    const { x, y, w, h } = area;
    const bcr = document.getElementById('effectCover').getBoundingClientRect();
    const condArr = [ // this is viewport relative
      { x, y },
      { x: x + w, y },
      { x: x + w, y: y + h },
      { x, y: y + h }
    ];
    commit('handleEffectPreselect', (w * h === 0) ? [] : getters.activeFragment.effects.filter(eid => {
      const ef = state.effects[eid];
      const efr = ef.content;

      const [top, left, width, height] = [efr.top, efr.left, efr.width, efr.height].map(v => v * state.playerScale / 100);

      // TODO: rotation-aware hit test
      const center = {
        x: left + width / 2,
        y: top + height / 2
      };
      const rotatedPoints = [
        { x: left, y: top },
        { x: left + width, y: top },
        { x: left + width, y: top + height },
        { x: left, y: top + height }
      ].map(p => rotateBy(p, center, efr.rotate));

      console.log(rotatedPoints);

      if (betweenDelta(state.currentProgress, ef.start + getters.activeFragment.start, ef.duration)
        && rotatedPoints.some(
          ({ x: curX, y: curY }, i) => {
            const viewportX = curX + bcr.left;
            const viewportY = curY + bcr.top;
            const isWithin = betweenDelta(viewportX, x, w) && betweenDelta(viewportY, y, h);
            const nextPoint = rotatedPoints[(i + 1) % 4];
            const curAngle = getAngle({ x: nextPoint.x - curX, y: nextPoint.y - curY });

            return isWithin || condArr.some((pt, j) => {
              const dir = Math.sin(getAngle({
                x: pt.x - viewportX,
                y: pt.y - viewportY
              }) - curAngle);
              const nextPt = condArr[(j + 1) % 4];
              const nextDir = Math.sin(getAngle({
                x: nextPt.x - viewportX,
                y: nextPt.y - viewportY
              }) - curAngle);

              if (dir * nextDir >= 0) {
                return false;
              }

              const curCondAngle = getAngle({
                x: nextPt.x - pt.x,
                y: nextPt.y - pt.y
              });
              const condDir = Math.sin(getAngle({
                x: viewportX - pt.x,
                y: viewportY - pt.y
              }) - curCondAngle);
              const nextCondDir = Math.sin(getAngle({
                x: nextPoint.x + bcr.left - pt.x,
                y: nextPoint.y + bcr.top - pt.y
              }) - curCondAngle);
              return condDir * nextCondDir < 0;
            });
          }
        )
      ) {
        if (ef.locked || ef.hidden) {
          return false;
        }
        const { timelineFilter, shapeNames, videoSeriesTagMode } = state;
        if (!matchFilter(ef, timelineFilter, shapeNames, videoSeriesTagMode)) {
          return false;
        }
        return true;
      }
      return false;
    }));
  },
  selectIntersecting({ state, commit, dispatch }) {
    commit('handleEffectSelect', state.preselectedEffectIds || []);
    dispatch('cleanNonEffectSelection');
    commit('handleSelectionDraw', false);
  },
  cleanNonEffectSelection({ state, commit }) {
    commit('handleKeyboardShortcutShow', false);
    commit('handleTrackSelect', null);
    commit('handleAudioSelect', null);
    if (state.currentSubmenu === 'BackgroundAudioFormat') {
      commit('handleCurrentSubmenu', 'VideoFormat');
    }
  },
  openEffectContextMenu({ state, getters, commit, dispatch }, { x, y, effectId, cover }) {
    function handleEffectReorder(f) {
      dispatch('changeActiveFragment', {
        ...getters.activeFragment,
        effects: f(getters.activeFragment.effects) || []
      });
    }

    function setRotate(effect, angle) {
      effect.content.rotate = angle;
      if (effect.container) {
        const containerEffect = state.effects[effect.container];
        if (containerEffect && containerEffect.type === 'group') {
          dispatch('adjustGroupSize', [containerEffect]);
        }
      }
    }

    const canGroup = !effectId;
    const canUngroup = state.selectedEffectIds.some(id => state.effects[id].type === 'group');

    const userBasics = state.userBasics;

    let showAddMaterial, showChangeMaterial, showEditMaterial, isMaterial, isText, isLinked, isTagged, isObjectFitContain;
    if (getters.selectedEffect) {
      const { type, children, linkId, content: efc, videoSeriesTags, userMaterialFit } = getters.selectedEffect;
      const { nameLinks } = getters.activeFragment;
      console.log(nameLinks);
      const isContainer = type == 'container' || type == 'textContainer';
      showAddMaterial = isContainer && !children.length;
      isMaterial = type === 'image' || type === 'video';
      isLinked = isMaterial && (nameLinks && nameLinks[efc.name] || linkId);
      isText = type === 'text' || type === 'textContainer' || type === 'wordArt';
      isTagged = videoSeriesTags;
      showChangeMaterial = (isContainer && children.length) || isMaterial;
      showEditMaterial = isContainer && children.length;
      isObjectFitContain = !!userMaterialFit;
    }
    console.log('selectedEffect', getters.selectedEffect)
    commit('handleContextMenuOpen', {
      x,
      y,
      items: [
        {
          text: '剪切',
          shortcut: 'Ctrl+X',
          action: () => {
            dispatch('cutEffect');
          }
        },
        {
          text: '复制',
          shortcut: 'Ctrl+C',
          action: () => {
            dispatch('copyEffect');
          }
        },
        {
          text: '粘贴',
          shortcut: 'Ctrl+V',
          action: () => {
            dispatch('pasteEffect');
          },
          disabled: !state.clipboard
        },
        {
          text: '选择图层',
          submenu: cover ? getters.activeFragment.effects.filter(eid => {
            if (eid === effectId) {
              return true;
            }
            const ef = state.effects[eid];
            const efr = ef.content;
            const [top, left, width, height] = [efr.top, efr.left, efr.width, efr.height].map(v => v * state.playerScale / 100);

            const bcr = document.getElementById('effectCover').getBoundingClientRect();

            // TODO: rotation-aware hit test
            const center = {
              x: left + width / 2 + bcr.left,
              y: top + height / 2 + bcr.top
            };
            const unrotatedMouse = rotateBy({ x, y }, center, -efr.rotate || 0);

            if (betweenDelta(state.currentProgress, ef.start + getters.activeFragment.start, ef.duration)
              && betweenDelta(unrotatedMouse.x, left + bcr.left, width)
              && betweenDelta(unrotatedMouse.y, top + bcr.top, height)
            ) {
              if (ef.locked || ef.hidden) {
                return false;
              }
              const { timelineFilter, shapeNames, videoSeriesTagMode } = state;
              if (!matchFilter(ef, timelineFilter, shapeNames, videoSeriesTagMode)) {
                return false;
              }
              return true;
            }
            return false;
          }).reverse().map(id => {
            const ef = state.effects[id];
            let prefix = labelPrefixes[ef.type];
            if (ef.type === 'lottie' && ef.isEffect) {
              prefix = '特效';
            }
            return {
              text: prefix ? `${prefix}: ${getEffectName(ef, state.shapeNames)}` : 'Unknown Effect',
              icon: effectId === id ? 'check' : '',
              action: () => {
                commit('handleEffectSelect', [id]);
              }
            };
          }) : [],
          disabled: !cover
        },
        {
          text: '顺序',
          disabled: !!(effectId && state.effects[effectId].container),
          submenu: [{
            text: '上移一层',
            action: () => {
              handleEffectReorder(effectId ? moveEffect.up(effectId) : moveEffect.upMulti(state.selectedEffectIds));
            }
          },
          {
            text: '下移一层',
            action: () => {
              handleEffectReorder(effectId ? moveEffect.down(effectId) : moveEffect.downMulti(state.selectedEffectIds));
            }
          },
          {
            text: '移到顶层',
            action: () => {
              handleEffectReorder(effectId ? moveEffect.top(effectId) : moveEffect.topMulti(state.selectedEffectIds));
            }
          },
          {
            text: '移到底层',
            action: () => {
              handleEffectReorder(effectId ? moveEffect.bottom(effectId) : moveEffect.bottomMulti(state.selectedEffectIds));
            }
          }]
        },
        {
          text: '旋转',
          disabled: !effectId,
          submenu: [
            // {
            //   text: '不旋转',
            //   action() {
            //     state.effects[effectId].content.rotate = 0;
            //   }
            // },
            {
              text: '90° (顺时针)',
              action() {
                setRotate(state.effects[effectId], 90);
              }
            },
            {
              text: '180°',
              action() {
                setRotate(state.effects[effectId], 180);
              }
            },
            {
              text: '90° (逆时针)',
              action() {
                setRotate(state.effects[effectId], 270);
              }
            }
          ]
        },
        {
          text: '组合',
          disabled: !(canGroup || canUngroup),
          submenu: [
            {
              text: '组合',
              action() {
                dispatch('groupEffects');
              },
              shortcut: 'Ctrl+G',
              disabled: !canGroup
            },
            {
              text: '取消组合',
              action() {
                dispatch('ungroupEffects');
              },
              disabled: !canUngroup
            }
          ]
        },
        {
          text: '添加素材',
          hidden: !showAddMaterial,
          action: () => {
            commit('handleContainerEdit', !state.editingContainer && effectId || null);
            commit('handleCurrentIcon', 'material');
            commit('handleCurrentMenu', 'MaterialMenu');
          }
        },
        {
          text: '更换素材',
          hidden: !showChangeMaterial || (state.isFisher && state.fisherInfo?.type === 'digitalHuman' && getters.selectedEffect.figure),
          action: () => {
            if (getters.selectedEffect.type == 'container' || getters.selectedEffect.type == 'textContainer') {
              commit('handleContainerEdit', !state.editingContainer && effectId || null);
              commit('handleCurrentIcon', 'material');
              commit('handleCurrentMenu', 'MaterialMenu');
            } else {
              commit('handleFilterShowing', false);
              dispatch('setEditStatus', true);
            }
          }
        },
        {
          text: '素材调整',
          hidden: !showEditMaterial,
          action: () => {
            commit('handleEffectSelect', [getters.currentEffect.children[0]])
          }
        },
        {
          text: '共享',
          hidden: userBasics ? !userBasics.is_test : true,
          submenu: [
            {
              text: '共享为组件素材',
              action() {
                commit('handleSavePresetShow', true);
                commit('handleSavePresetType', 'preset');
              }
            },
            {
              text: '共享为组合文本',
              action() {
                commit('handleSavePresetShow', true);
                commit('handleSavePresetType', 'combination');
              }
            }
          ]
        },
        {
          text: '系列视频选项',
          hidden: userBasics ? !userBasics.is_open_template : true,
          submenu: [
            {
              text: isLinked ? '关联素材设置' : '添加关联...',
              disabled: !isMaterial,
              action() {
                commit('handleLinkMaterialVisible', true);
              }
            },
            {
              text: '取消关联',
              hidden: !isLinked,
              action() {
                const { linkId, content: efc } = getters.selectedEffect;
                const { nameLinks, effects } = getters.activeFragment;
                const getEffect = id => state.effects[id];
                Modal.confirm({
                  title: '提示',
                  content: '与当前素材的名称关联和自定义关联将被清除。',
                  onOk() {
                    if (linkId) {
                      getters.selectedEffect.linkId = null;
                      const linkedEffects = [].concat.apply([],
                        effects.map(getEffect)
                          .map(ef => [ef].concat(ef.children ? ef.children.map(getEffect) : []))
                      ).filter(ef => ef.linkId === linkId);
                      if (linkedEffects.length === 1) {
                        linkedEffects[0].linkId = null;
                      }
                    }
                    if (nameLinks && nameLinks[efc.name]) {
                      Vue.delete(nameLinks, efc.name);
                    }

                    message.info('已取消当前素材关联。');
                  }
                });
              }
            },
            {
              text: '系列视频标签',
              disabled: !isMaterial && !isText,
              action() {
                if (isMaterial) {
                  commit('handleVideoSeriesTagVisible', true);
                } else {
                  commit('handleTextVideoSeriesTagVisible', true);
                }
              }
            },
            {
              text: '取消标签',
              hidden: !isTagged,
              action() {
                const ef = getters.selectedEffect;
                Modal.confirm({
                  title: '提示',
                  content: `确认要取消该${isText ? '文本' : '素材'}的系列视频标签吗?`,
                  onOk() {
                    ef.videoSeriesTags = null;
                    Vue.set(ef, 'videoSeriesTagParams', null);
                    message.info('已取消系列视频标签。');
                    dispatch('cleanupTags');
                  }
                });
              }
            },
            {
              text: '用户素材适应',
              disabled: !isMaterial,
              submenu: [
                {
                  text: '包含',
                  icon: isObjectFitContain ? 'check' : '',
                  action() {
                    const ef = getters.selectedEffect;
                    Vue.set(ef, 'userMaterialFit', true);
                    message.info('已更改用户素材适应设置');
                  }
                },
                {
                  text: '覆盖',
                  icon: isObjectFitContain ? '' : 'check',
                  action() {
                    const ef = getters.selectedEffect;
                    Vue.set(ef, 'userMaterialFit', false);
                    message.info('已更改用户素材适应设置');
                  }
                }
              ]
            }
          ]
        },
        {
          text: '编辑文本',
          hidden: !isText,
          action() {
            commit('handleEffectEdit', effectId);
          }
        },
        {
          text: '元素重命名',
          disabled: !effectId,
          action: () => {
            dispatch('renameEffect', { effectId });
          }
        },
        getters.selectedEffect?.type =='image' ?
        {
          text: getters.selectedEffect?.figure?'取消数字人标记':'数字人标记',
          hidden: userBasics ? !userBasics.is_open_template : true,
          action: ()=> {
            const ef = getters.selectedEffect;
            Vue.set(ef, 'figure', !!!getters.selectedEffect?.figure);
          }
        }:{},
        getters.selectedEffect?.figure ? {} :{
          text: '删除',
          action: async () => {
            // await new Promise(resolve => {
            //   setTimeout(resolve, 0);
            // });
            if (effectId) {
              const done = await dispatch('processRemoveMaterialItem', effectId);
              if (done) {
                commit('handleEffectSelect', []);
              }
            } else {
              state.selectedEffectIds.forEach(effectId => {
                dispatch('processRemoveMaterialItem', effectId);
              });
              commit('handleEffectSelect', []);
            }
          },
          shortcut: 'Del'
        }
      ]
    });
  },
  cutEffect({ state, commit, dispatch }) {
    const { activeFragmentIndex, fragments, clipboard, selectedEffectIds, clipboardType, effects } = state;
    if (!selectedEffectIds.length) {
      return;
    }
    if (clipboardType === 'cut') {
      // TODO: remove it
      clipboard.forEach(cb => {
        delete effects[cb];
      });
    }
    // the effect cannot be deleted. It is cut.
    state.clipboardType = 'cut';
    state.clipboard = [].concat(selectedEffectIds);

    selectedEffectIds.forEach(effectId => {
      const effect = effects[effectId];
      if (effect && effect.container) {
        const containerEffect = effects[effect.container];
        containerEffect.children = containerEffect.children.filter(item => '' + item !== '' + effectId);
        if (containerEffect.children.length <= 1) {
          dispatch('processUngroupEffects', { groups: [containerEffect] });
        } else {
          dispatch('adjustGroupSize', [containerEffect]);
        }
      } else {
        const fragment = fragments[activeFragmentIndex];
        fragment.effects = fragment.effects.filter(item => '' + item !== '' + effectId);
      }
    });
    commit('handleEffectSelect', []);
  },
  copyEffect({ state }) {
    const { clipboard, selectedEffectIds, clipboardType, effects } = state;
    if (!selectedEffectIds.length) {
      return;
    }
    if (clipboardType === 'cut') {
      // TODO: remove it
      clipboard.forEach(cb => {
        delete effects[cb];
      });
    }
    state.clipboardType = 'copy';
    state.clipboard = [].concat(selectedEffectIds);
  },
  pasteEffect({ state, commit, dispatch }) {
    const { activeFragmentIndex, fragments, clipboard, effects } = state;
    if (clipboard) {
      const now = +new Date();
      const pastedEffects = {};
      const fragment = fragments[activeFragmentIndex];

      let fragmentEffects = fragment.effects;
      const effectIds = clipboard.map((cb, i) => {
        let effect = effects[cb];
        if (!effect) {
          return;
        }

        let effectId = (now + i) + '';
        let children;
        let childEffects = {};
        if (effect.children) {
          children = effect.children.map((c, i) => {
            const childEffectId = [effectId, i].join('c');
            const childEffect = effects[c];
            childEffects[childEffectId] = JSON.parse(JSON.stringify({
              ...childEffect,
              id: childEffectId,
              container: effectId,
              children: undefined
            }));
            return childEffectId;
          });
        }

        const nextEffect = JSON.parse(JSON.stringify({
          ...effect,
          id: effectId,
          container: undefined,
          children
        }));

        const { duration } = fragment;
        nextEffect.start = Math.max(clamp(nextEffect.start, 0, duration - nextEffect.duration), 0);
        nextEffect.duration = clamp(nextEffect.duration, 400, duration);

        Object.assign(
          pastedEffects,
          childEffects,
          { [effectId]: nextEffect }
        );

        let done;

        fragmentEffects = [].concat.apply([], fragmentEffects.map(ef => {
          if (ef === cb && clipboard.length === 1) {
            done = true;
            return [ef, effectId];
          }
          return ef;
        })).concat(done ? [] : effectId);

        if (!matchFilter(nextEffect, state.timelineFilter, state.shapeNames, state.videoSeriesTagMode)) {
          commit('handleTimelineFilter', '');
        }
        return effectId;
      }).filter(id => !!id);
      commit('handleEffectSelect', effectIds);
      commit('handleEffects', {
        ...effects,
        ...pastedEffects
      });
      dispatch('changeActiveFragment', {
        ...fragment,
        effects: fragmentEffects
      });
      return;
    }
    message.error('剪贴板为空。');
  },
  selectAll({ state, getters, commit }) {
    const { effects, timelineFilter } = state;
    const { activeFragment } = getters;
    if (activeFragment) {
      const arr = activeFragment.effects.filter(ef => !effects[ef].locked
        && !effects[ef].hidden
        && matchFilter(effects[ef], timelineFilter, state.shapeNames, state.videoSeriesTagMode));
      commit('handleEffectSelect', arr);
    }
  },
  // 重命名
  renameEffect({ state, commit }, { effectId }) {
    state.renameId = effectId;
    commit('handleEffectSelect', [effectId]);
    commit('handleRenameVisible', true);
  },
  groupEffects({ state, getters, commit }) {
    const { activeFragment } = getters;
    const { effects, selectedEffectIds } = state;

    if (selectedEffectIds.length <= 1) {
      return;
    }

    const groupable = selectedEffectIds.every(id => {
      const ef = effects[id];
      return !!(ef && !ef.children && !ef.container);
    });

    if (!groupable) {
      message.error('已检测到无法组合的选择内容。');
      return;
    }

    const arr = [];
    const lookup = {};

    const rects = [].concat.apply([], selectedEffectIds.map(id => {
      lookup[id] = true;
      return rotateRect(effects[id].content);
    }));

    const nextEffectList = activeFragment.effects.filter(id => {
      if (id in lookup) {
        arr.push(id); // keep original order.
        return false;
      }
      return true;
    });

    const left = Math.min.apply(Math, rects.map(r => r.x));
    const right = Math.max.apply(Math, rects.map(r => r.x));
    const top = Math.min.apply(Math, rects.map(r => r.y));
    const bottom = Math.max.apply(Math, rects.map(r => r.y));

    const efc = {
      top,
      left,
      width: right - left,
      height: bottom - top,
      name: 'Group',
      rotate: 0,
      opacity: 100,
      flip: 'none'
    };

    const groupEffect = {
      id: '' + (+new Date()),
      type: 'group',
      content: efc,
      children: arr,
      start: 0,
      duration: Math.min(6e3, activeFragment.duration),
      enter: 'none',
      enterDuration: 1e3,
      leave: 'none',
      leaveDuration: 1e3,
      showTracks: false,
      locked: false,
      hidden: false,
      tracks: [
        {
          id: 1,
          start: 1e3,
          duration: 1e3,
          text: 'animation',
          effectType: 'gradientFade', // TODO: group effects are not supported
          params: {
            direction: 'left'
          }
        }
      ]
    };

    const nextEffects = {
      ...effects,
      [groupEffect.id]: groupEffect
    };

    selectedEffectIds.forEach(id => {
      const ef = effects[id];

      nextEffects[id] = {
        ...ef,
        container: groupEffect.id,
        content: {
          ...ef.content,
          top: ef.content.top - top,
          left: ef.content.left - left
        }
      };
    });

    console.log(nextEffectList);
    activeFragment.effects = [].concat(nextEffectList, groupEffect.id);
    commit('handleEffects', nextEffects);

    commit('handleEffectSelect', [groupEffect.id]);
  },
  processUngroupEffects({ state, getters, commit }, { groups, done }) {
    const { activeFragment } = getters;
    const { effects } = state;

    const ret = []; // Selectable IDs released from ungrouping
    const lookup = {};
    const nextEffects = { ...effects };

    groups.forEach(g => {
      const gefc = g.content;
      lookup[g.id] = [].concat(g.children);

      const groupCenter = {
        x: gefc.width / 2,
        y: gefc.height / 2
      };

      ret.push.apply(ret, g.children.filter(cid => { // select all its children
        const ef = effects[cid];
        const efc = ef.content;

        const center = {
          x: efc.left + efc.width / 2,
          y: efc.top + efc.height / 2
        };
        const rotatedCenter = rotateBy(center, groupCenter, gefc.rotate);

        const nextEfc = {
          ...efc,
          left: rotatedCenter.x + gefc.left - efc.width / 2,
          top: rotatedCenter.y + gefc.top - efc.height / 2,
          rotate: efc.rotate + gefc.rotate
        };

        // TODO: flip
        switch (gefc.flip) {
          case 'horizontal': {
            center.x = groupCenter.x * 2 - center.x;
            const rotatedCenter = rotateBy(center, groupCenter, gefc.rotate);
            nextEfc.left = rotatedCenter.x + gefc.left - efc.width / 2;
            nextEfc.top = rotatedCenter.y + gefc.top - efc.height / 2;
            nextEfc.flip = efc.flip && efc.flip !== 'none' ? 'none' : 'horizontal';
            nextEfc.rotate = gefc.rotate - efc.rotate;
            if (efc.flip === 'vertical') {
              nextEfc.rotate += 180;
            }
            break;
          }
          case 'vertical': {
            center.y = groupCenter.y * 2 - center.y;
            const rotatedCenter = rotateBy(center, groupCenter, gefc.rotate);
            nextEfc.left = rotatedCenter.x + gefc.left - efc.width / 2;
            nextEfc.top = rotatedCenter.y + gefc.top - efc.height / 2;
            nextEfc.flip = efc.flip && efc.flip !== 'none' ? 'none' : 'vertical';
            nextEfc.rotate = gefc.rotate - efc.rotate;
            if (efc.flip === 'horizontal') {
              nextEfc.rotate += 180;
            }
            break;
          }
        }

        const nextEffect = {
          ...ef,
          content: nextEfc
        };

        delete nextEffect.container;

        nextEffects[cid] = nextEffect;

        return !ef.locked && !ef.hidden && matchFilter(ef, state.timelineFilter, state.shapeNames);
      }));

      delete nextEffects[g.id];
    });

    commit('handleEffects', nextEffects);
    activeFragment.effects = [].concat.apply(
      [],
      activeFragment.effects.map(id => id in lookup ? lookup[id] : id)
    );

    if (done) {
      done(ret);
    }
  },
  ungroupEffects({ state, commit, dispatch }) {
    // TODO:
    const { effects, selectedEffectIds } = state;

    const ret = []; // this will be set to selection

    const groups = selectedEffectIds.map(id => effects[id]).filter(ef => {
      if (ef.type === 'group') {
        return true;
      }
      ret.push(ef.id);
      return false;
    });

    if (!groups.length) {
      message.error('No groups were selected for ungrouping.');
      return;
    }

    dispatch('processUngroupEffects', {
      groups,
      done(val) {
        commit('handleEffectSelect', ret.concat(val));
      }
    });
  },
  adjustGroupSize({ state }, groups) {
    groups.forEach(group => {
      const sibs = group.children.map(c => state.effects[c]);
      const pts = [].concat.apply([], sibs.map(ef => rotateRect(ef.content)));
      const pefc = group.content;

      pts.forEach(pt => {
        switch (pefc.flip) {
          case 'horizontal':
            pt.x = pefc.width - pt.x;
            break;
          case 'vertical':
            pt.y = pefc.height - pt.y;
            break;
        }
      });

      const left = Math.min.apply(Math, pts.map(p => p.x));
      const right = Math.max.apply(Math, pts.map(p => p.x));
      const top = Math.min.apply(Math, pts.map(p => p.y));
      const bottom = Math.max.apply(Math, pts.map(p => p.y));

      const { x, y } = rotateBy({ // FIXME: a vector is rotated instead that indicates how much the center should be shifted
        x: (right - left - pefc.width) / 2,
        y: (bottom - top - pefc.height) / 2
      }, { x: 0, y: 0 }, pefc.rotate);

      const { x: rotatedX, y: rotatedY } = rotateBy({ x: left, y: top }, { x: 0, y: 0 }, pefc.rotate);

      pefc.left += rotatedX + pefc.width / 2 + x - (right - left) / 2;
      pefc.top += rotatedY + pefc.height / 2 + y - (bottom - top) / 2;
      sibs.forEach(ef => {
        switch (pefc.flip) {
          case 'horizontal':
            ef.content.left -= pefc.width - right;
            ef.content.top -= top;
            break;
          case 'vertical':
            ef.content.left -= left;
            ef.content.top -= pefc.height - bottom;
            break;
          default:
            ef.content.left -= left;
            ef.content.top -= top;
        }
      });
      pefc.width = right - left;
      pefc.height = bottom - top;
    });
  },
  async applyVideoTemplate(
    { state, commit, dispatch },
    { id, type, screenRatio: usedScreenRatio, screenHeight: usedScreenHeight, method }
  ) {
    const screenRatio = usedScreenRatio || state.screenRatio;
    const screenHeight = usedScreenHeight || state.screenHeight;
    const aspectRatio = screenHeight / 480;
    const result = method
      ? { value: method }
      : await new Promise(resolve => {
        let value = 'after';
        const dialogContent = h => [
          h('a-form-item',
            {
              attrs: {
                label: '应用方式',
                labelCol: { span: 6 },
                labelAlign: 'left',
                wrapperCol: { span: 18 }
              },
              style: {
                margin: '-8px 0 14px'
              }
            },
            [
              h('a-select', {
                style: { width: '100%' },
                attrs: {
                  value,
                  options: [
                    {
                      value: 'replace',
                      label: '删除当前所有片段'
                    },
                    {
                      value: 'append',
                      label: '添加到最后一个片段之后'
                    },
                    {
                      value: 'before',
                      label: '添加到当前片段之前'
                    },
                    {
                      value: 'after',
                      label: '添加到当前片段之后'
                    }
                  ]
                },
                on: {
                  change(e) {
                    console.log('change')
                    value = e;
                    modal.update({
                      content: dialogContent
                    });
                  }
                }
              })
            ]),
          h('p',
            {
              style: {
                margin: 0
              }
            },
            [h('strong', {}, '提示：')].concat(value === 'replace'
              ? [
                '该操作将',
                h('span', { style: { color: '#ff4d4f' } }, '删除当前所有片段内容！')
              ] : [],
              '是否确认使用？'
            )
          )
        ];
        const modal = Modal.confirm({
          title: '模板应用',
          icon: 'warning',
          content: dialogContent,
          width: 480,
          onOk() {
            resolve({ value });
          },
          onCancel() {
            resolve(false);
          }
        });
      });
    if (!result) {
      return false;
    }

    console.log(result.value);
    commit('handleLoading', true);
    try {
      const fragments = [];
      const audios = {};
      const effects = state.clipboard ? {
        [state.clipboard]: state.effects[state.clipboard]
      } : {};
      let start = 0;
      let duration = 0;
      // TODO: append mode
      switch (result.value) {
        case 'append':
          {
            console.log('append');
            fragments.push.apply(fragments, state.fragments);
            Object.assign(effects, state.effects);
            Object.assign(audios, state.audios);
            const frag = fragments[fragments.length - 1];
            if (frag) {
              start = frag.start + frag.duration - (frag.transition ? frag.transition.duration : 0);
            }
          }
          break;
        case 'before':
          {
            fragments.push.apply(fragments, state.fragments.slice(0, state.activeFragmentIndex));
            Object.assign(effects, state.effects);
            Object.assign(audios, state.audios);
            const frag = fragments[state.activeFragmentIndex - 1]; // before inserted fragment.
            if (frag) {
              start = frag.start + frag.duration - (frag.transition ? frag.transition.duration : 0);
            }
          }
          break;
        case 'after':
          // throw new Error('not supported');
          {
            fragments.push.apply(fragments, state.fragments.slice(0, state.activeFragmentIndex + 1));
            Object.assign(effects, state.effects);
            Object.assign(audios, state.audios);
            const frag = fragments[state.activeFragmentIndex];
            if (frag) {
              start = frag.start + frag.duration - (frag.transition ? frag.transition.duration : 0);
            }
          }
          break;
      }
      const origStart = start;

      if (type > 5) {
        let nextKey = +new Date();
        const res = await post('template/draft', { id });
        const editorData = res.params;

        const {
          fragments: templateFragments,
          effects: templateEffects,
          screenHeight,
          audios: templateAudios = {}
        } = editorData;

        const nextTemplateEffects = {};
        const effectKeyLookup = {};

        normalizeEffects(templateEffects);
        const mapChildren = [];

        Object.keys(templateEffects).forEach(key => {
          const ef = templateEffects[key];
          if (ef.type === 'text') {
            ef.content.fontSize /= screenHeight / state.screenHeight;
          }

          if (ef.children) {
            mapChildren.push(ef);
          }

          if (key in effects) {
            nextKey++;
            ef.id = '' + nextKey;
            nextTemplateEffects[nextKey] = ef;
            effectKeyLookup[key] = '' + nextKey;
          } else {
            nextTemplateEffects[key] = ef;
          }
        });
        mapChildren.forEach(ef => {
          ef.children = ef.children.map(key => key in effectKeyLookup ? effectKeyLookup[key] : key);
        });
        Object.assign(effects, nextTemplateEffects);

        // ditto for audios
        const nextTemplateAudios = {};
        const audioKeyLookup = {};
        normalizeAudios(templateAudios);
        Object.keys(templateAudios).forEach(key => {
          const audio = templateAudios[key];
          if (key in audios) {
            nextKey++;
            const id = 'audio' + nextKey;
            audio.id = id;
            nextTemplateAudios[id] = audio;
            audioKeyLookup[key] = id;
          } else {
            nextTemplateAudios[key] = audio;
          }
        });
        Object.assign(audios, nextTemplateAudios);

        templateFragments.forEach((frag, i) => {
          frag.start += start;
          frag.id = 'frag' + nextKey + i;
          frag.effects = frag.effects.map(key => key in effectKeyLookup ? effectKeyLookup[key] : key);

          if (typeof frag.audios === 'undefined') {
            frag.audios = [];
          } else {
            frag.audios = frag.audios.map(key => key in audioKeyLookup ? audioKeyLookup[key] : key);
          }
        });
        fragments.push.apply(fragments, templateFragments);
      } else {
        const res = await post('listrule', { id });
        console.log(res);
        const { rule = [], resolution = '1280*720' } = res;

        const transformedRules = await Promise.all(
          [].concat(rule).map((r, i) => effectsTransformer(r, aspectRatio, screenRatio, screenHeight, resolution, 'seed' + i))
        );
        transformedRules.forEach(({
          values: newEffects,
          keys: newFragmentEffects
        }, i) => {
          normalizeEffects(newEffects);
          const fragRule = rule[i];
          const newFragment = fragmentsTransformer(rule, start + duration, fragRule.duration / 1e3);
          start = newFragment.start;
          duration = fragRule.duration;
          const nextRule = rule[i + 1];
          if (nextRule && nextRule.transitionArray) {
            console.log('transition is enabled');
            newFragment.transition = {
              name: nextRule.transitionArray.type,
              duration: 1e3,
              start: newFragment.duration - 1e3
            };
            start -= 1e3;
          }
          Object.assign(effects, newEffects);
          fragments.push({
            ...newFragment,
            effects: newFragmentEffects,
            hideStamp: false,
            id: +new Date() + i + ''
          });
        });
      }
      if (result.value === 'after') {
        if (fragments.length) {
          const lastFrag = fragments[fragments.length - 1];
          start = lastFrag.start + lastFrag.duration;
        }
        fragments.push.apply(
          fragments,
          state.fragments.slice(state.activeFragmentIndex + 1).map(frag => ({
            ...frag,
            start: frag.start + start - origStart
          }))
        );
      } else if (result.value === 'before') {
        if (fragments.length) {
          const lastFrag = fragments[fragments.length - 1];
          start = lastFrag.start + lastFrag.duration;
        }
        fragments.push.apply(
          fragments,
          state.fragments.slice(state.activeFragmentIndex).map(frag => ({
            ...frag,
            start: frag.start + start - origStart
          }))
        );
      }
      if (result.value === 'replace' && state.clipboard) {
        state.clipboardType = 'cut';
      }
      console.log(fragments);
      commit('handleEffects', effects);
      commit('handleFragments', fragments);
      commit('handleAudios', audios);
      commit('handleActiveFragmentIndex', 0);
      commit('handleCurrentIcon', 'snippet');
      commit('handleCurrentMenu', 'VideoClipList');
      commit('handleTemplateUse', id);
      if (usedScreenRatio) {
        commit('handleScreenRatio', screenRatio);
      }
      if (usedScreenHeight) {
        dispatch('setScreenHeight', screenHeight);
      }
    } catch (e) {
      // TODO:
      console.log(e);
    }
    commit('handleLoading', false);

    return true;
  },
  async previewCustomTemplate({ commit }, id) {
    commit('handleLoading', true);
    const msg = message.info('模板预览内容加载中');
    const res = await post('template/draft', { id });
    const editorData = res.params;

    const {
      fragments,
      effects,
      screenHeight,
      stamp,
      stampEnabled
    } = editorData;

    commit('handleTemplatePlayerVisible', true);
    commit('handleTemplatePlayerData', {
      fragments,
      effects,
      screenHeight,
      stamp: stampEnabled && stamp
    });
    msg();
    commit('handleLoading', false);
  },
  initUndoStack({ state, commit }) {
    const {
      screenRatio,
      fragments,
      videoName,
      effects,
      screenHeight,
      myVideoMusic,
      musicStartEnd,
      musicVolume,
      setupMusic,
      stampEnabled,
      stamp,
      ttsRule,
      translationEnabled,
      selectedLanguages,
      useTTSLanguages,
      audios,
      subtitleTracks,
      languageOptions,
      languageSex,
      useCustomTTS,
      customTTS,
      customTTSIds,
      descKeywords
    } = state;
    commit('handleUndoStack', [
      JSON.stringify({
        screenRatio,
        fragments,
        videoName,
        effects,
        screenHeight,
        myVideoMusic,
        musicStartEnd,
        musicVolume,
        setupMusic,
        stampEnabled,
        stamp,
        ttsRule,
        translationEnabled,
        selectedLanguages,
        useTTSLanguages,
        // below are recorded but not watched
        activeFragmentIndex: 0,
        activeTransitionIndex: 0,
        selectedEffectIds: [],
        audios,
        subtitleTracks,
        languageOptions,
        languageSex,
        useCustomTTS,
        customTTS,
        customTTSIds,
        descKeywords
      })
    ]);
    commit('handleUndoPos', 0);
  },
  recordUndoStack({ state, commit }) {
    const {
      screenRatio,
      fragments,
      videoName,
      effects,
      screenHeight,
      myVideoMusic,
      musicStartEnd,
      musicVolume,
      setupMusic,
      stampEnabled,
      stamp,
      ttsRule,
      translationEnabled,
      selectedLanguages,
      useTTSLanguages,
      audios,
      subtitleTracks,
      languageOptions,
      // below are recorded but not watched
      activeFragmentIndex,
      activeTransitionIndex,
      selectedEffectIds,
      selectedAudioId,
      musicFade,
      usedVideoScriptId,
      languageSex,
      useCustomTTS,
      customTTS,
      customTTSIds,
      descKeywords
    } = state;
    commit(
      'handleUndoStack',
      state.undoStack.slice(0, state.undoPos + 1).concat(
        JSON.stringify({
          screenRatio,
          fragments,
          videoName,
          effects,
          screenHeight,
          myVideoMusic,
          musicStartEnd,
          musicVolume,
          setupMusic,
          stampEnabled,
          stamp,
          ttsRule,
          translationEnabled,
          selectedLanguages,
          useTTSLanguages,
          activeFragmentIndex,
          activeTransitionIndex,
          selectedEffectIds,
          audios,
          subtitleTracks,
          selectedAudioId,
          musicFade,
          usedVideoScriptId,
          languageOptions,
          languageSex,
          useCustomTTS,
          customTTS,
          customTTSIds,
          descKeywords
        })
      )
    );
    commit('handleUndoPos', state.undoPos + 1);
  },
  processUndo({ state, commit }, delta) {
    commit('handleRecordDisabled', true);

    const { undoStack, undoPos } = state;
    const nextUndoPos = undoPos + delta;
    if (undoStack[nextUndoPos]) {
      const {
        screenRatio,
        fragments,
        videoName,
        effects,
        screenHeight,
        myVideoMusic,
        musicStartEnd,
        musicVolume,
        setupMusic,
        stampEnabled,
        stamp,
        ttsRule,
        translationEnabled,
        selectedLanguages,
        useTTSLanguages,
        activeFragmentIndex,
        activeTransitionIndex,
        selectedEffectIds,
        audios,
        subtitleTracks,
        selectedAudioId,
        musicFade,
        usedVideoScriptId,
        languageOptions,
        languageSex,
        useCustomTTS,
        customTTS,
        customTTSIds,
        descKeywords
      } = JSON.parse(undoStack[nextUndoPos]);

      commit('handleEffects', effects);
      commit('handleFragments', fragments);
      commit('handleTTSRule', ttsRule);
      commit('handleScreenRatio', screenRatio);
      commit('handleScreenHeight', screenHeight);
      commit('handleVideoName', videoName);
      commit('handleCurrentMusic', myVideoMusic);
      commit('handleMusicStartEnd', musicStartEnd);
      commit('handleMusicVolume', musicVolume);
      commit('handleMyVideoMusic', myVideoMusic);
      commit('handleSetupMusic', setupMusic);
      commit('handleStampEnabled', stampEnabled);
      // commit('handleStampUrl', [stamp.url, stamp.aspectRatio]);
      state.stamp = stamp;
      commit('handleTranslationEnabled', translationEnabled);
      commit('handleLanguageSelect', selectedLanguages);
      commit('handleUseTTSLanguages', useTTSLanguages);
      commit('handleUndoPos', nextUndoPos);
      commit('handleAudios', audios);
      commit('handleSubtitleTracks', subtitleTracks);
      state.languageOptions = languageOptions;

      console.log(selectedEffectIds);
      commit('handleActiveFragmentIndex', activeFragmentIndex);
      commit('handleActiveTransitionIndex', activeTransitionIndex);
      commit('handleEffectSelect', selectedEffectIds);
      commit('handleAudioSelect', selectedAudioId);

      if (musicFade) {
        commit('handleMusicFade', musicFade);
      }

      if (languageSex) {
        commit('handleLanguageSex', languageSex);
      }

      commit('handleVideoScriptUse', usedVideoScriptId || null);

      commit('handleCustomTTSUse', useCustomTTS);
      commit('handleCustomTTS', customTTS);
      commit('handleCustomTTSIds', customTTSIds);
      commit('handleDescKeywords', descKeywords);

      setTimeout(() => {
        commit('handleRecordDisabled', false);
      }, 20);
    }
  },
  undo({ dispatch }) {
    dispatch('processUndo', -1);
  },
  redo({ dispatch }) {
    dispatch('processUndo', 1);
  },
  async getLiFisherSites({ commit }) {
    const data = await get('fish/site');
    if (data && data.length) {
      commit('handleLiFisherSites', data);
    }
  },
  setMaterialTop(_, { id, value }) {
    return post('material/topping', {
      id,
      toping: value ? 2 : 1
    });
  },
  deleteMaterial({ commit }, { id, done }) {
    Modal.confirm({
      title: '确定删除此素材?',
      content: '素材被删除后不可恢复。',
      onOk() {
        commit('handleLoading', true);
        post('drop-material', { id }).then(() => {
          message.info('素材已被删除');
          if (done) {
            return done();
          }
        }).then(() => {
          commit('handleLoading', false);
        });
      }
    });
  },
async getUserBasics({ state, commit }) {
    const data = await get('user/basics');
    console.log('isFisher', state.isFisher);
    if (state.isFisher) {
      const isDigitalHuman = state.fisherInfo.type === 'digitalHuman';
      const noQuota = isDigitalHuman ? data.digital_people_quantity <= 0 : data.can_count <= 0;
      if (noQuota) {
        Modal.error({
          title: '无可用视频配额',
          content: '您的视频配额不足，如需继续创建请联系客服! 温馨提示：生成失败的视频也占用视频配额数，您可以删除生成失败的视频以恢复可用配额。'
        });
      }
    }
  // data.can_count = 0
  // console.log('data',data.can_count);
    commit('handleUserBasics', data)
  },
  getUserMeal,
  async loadShapeList({ state, commit }) {
    const { data } = await get('assembly/lists', { type: 4, limit: 100 });
    const ret = {};
    const metaRet = {};
    commit('handleShapes', data.map(item => {
      ret[item.flag] = item.name;
      metaRet[item.flag] = item;
      return item.flag;
    }));

    commit('handleShapeNames', Object.assign({}, state.shapeNames, ret));
    commit('handleShapeMetadata', Object.assign({}, state.shapeMetadata, metaRet));
  },
  async loadContainerList({ state, commit }) {
    const { data } = await get('assembly/lists', { type: 5, limit: 100 });
    const ret = {};
    const metaRet = {};
    commit('handleContainers', data.map(item => {
      ret[item.flag] = item.name;
      metaRet[item.flag] = item;
      return item.flag;
    }).filter(x => x !== 'textContainer'));

    commit('handleShapeNames', Object.assign({}, state.shapeNames, ret));
    commit('handleShapeMetadata', Object.assign({}, state.shapeMetadata, metaRet));
  },
  async loadGeneralEffectList({ state, commit }) {
    const { list } = await get('video-effect/lists', { type: 1, limit: 100 });
    const ret = {};
    commit('handleGeneralEffects', list.map(item => {
      ret[item.flag] = item.name;
      return item.flag;
    }).filter(x => x in textEffectMap));

    commit('handleEffectNames', Object.assign({}, state.effectNames, ret));
  },
  async loadTextEffectList({ state, commit }) {
    const { list } = await get('video-effect/lists', { type: 3, limit: 100 });
    const ret = {};
    commit('handleTextEffects', list.map(item => {
      ret[item.flag] = item.name;
      return item.flag;
    }).filter(x => x in textEffectMap));

    commit('handleEffectNames', Object.assign({}, state.effectNames, ret));
  },
  async loadTransitionList({ state, commit }) {
    const { list } = await get('video-effect/lists', { type: 2, limit: 100 });
    const ret = { none: '无' };
    commit('handleTransitions', list.map(item => {
      ret[item.flag] = item.name;
      return item.flag; // TODO: filter
    }));

    commit('handleTransitionNames', ret);
  },
  async addCollect({ commit }, data) {
    let res = await post('my_collect/' + data.type + '/add_collect', data)
    message.success('收藏成功');
    return res
  },
  async delCollect({ commit }, { type, id }) {
    let res = post('my_collect/' + type + '/del_collect', { id })
    message.success('取消收藏成功');
    return res
  },
  async getMineCollectTemplates({ state, commit }, { keyword, page = 1 }) {
    let { list, total } = await get('my_collect/template/collects', { page, size: 20, keyword }, false);
    let last = Math.ceil(total / 20) <= page;
    commit('handleVideoTemplateList', (page === 1 ? [] : state.videoTemplateList).concat(list));
    return { last };
  },
  async getMineCollectSnippets({ state, commit }, { keyword, page = 1 }) {
    let { list, total } = await get('my_collect/fragment/collects', { page, size: 20, keyword }, false);
    let last = Math.ceil(total / 20) <= page;
    commit('handleTemplateList', (page === 1 ? [] : state.templateList).concat(list));
    return { last };
  },
  async getMineCollectAnimes({ state, commit }, { keyword, page = 1, type = 1 }) {
    let { list, total } = await get('my_collect/lottie/collects', { page, size: 20, keyword, type }, false);
    let last = Math.ceil(total / 20) <= page;
    commit('handleMaterialList', (page === 1 ? [] : state.materialList).concat(list));
    return { last };
  },
  async getMineCollectEffects({ dispatch }, { keyword, page = 1 }) {
    return dispatch('getMineCollectAnimes', { keyword, page, type: 2 });
  },
  async getMineCollectDecals({ state, commit }, { keyword, page = 1 }) {
    let { list, total } = await get('my_collect/assembly/collects', { page, size: 20, keyword }, false);
    let last = Math.ceil(total / 20) <= page;
    commit('handleMaterialList', (page === 1 ? [] : state.materialList).concat(list));
    return { last };
  },
  async getMineCollectMaterials({ state, commit }, { keyword, page = 1 }) {
    let { list, total } = await get('my_collect/material/collects', { page, size: 30, keyword }, false);
    let last = Math.ceil(total / 30) <= page;
    commit('handleMaterialList', (page === 1 ? [] : state.materialList).concat(list));
    return { last };
  },
  async getMineCollectMusics({ state, commit }, { keyword, page = 1 }) {
    let { list, total } = await get('my_collect/material/collects', { page, size: 20, keyword, material_type: 6 }, false);
    let last = Math.ceil(total / 20) <= page;
    commit('handleMusicList', (page === 1 ? [] : state.musicList).concat(list));
    return { last };
  },
  async updateMateriaTag({ commit }, { id, label }) {
    let res = await post('updatematerialaber', { id, label })
    return res
  },
  async batchUpdateMateriaTag({ commit }, { id, label }) {
    let res = await post('batchupdatematerialaber', { id, label })
    return res
  },
  async searchMateriaTag({ commit }, { name }) {
    let res = await post('seartchlabel', { name })
    return res
  },
  async delMateriaTag({ commit }, { id, label }) {
    let res = await post('delmaterialaber', { id, label })
    return res
  },
  saveSelectionToPreset({ state }, { name, url, type }) {
    const {
      effects,
      selectedEffectIds,
      screenHeight,
      screenRatio
    } = state;

    if (!selectedEffectIds.length) {
      message.info('Nothing was selected');
      return;
    }

    // TODO:
    const reverseEffectScale = effect => {
      const efc = { ...effect.content };
      const factor = 720 / screenHeight; // TODO: other default screen heights
      if (effect.type === 'text') {
        efc.fontSize *= factor;
      }

      return {
        ...effect,
        id: undefined,
        content: efc,
        tracks: effect.tracks && effect.tracks.map(track => {
          if (effectParams[track.effectType]) {
            const params = { ...effectParams[track.effectType] };
            if (track.params) {
              Object.keys(track.params).forEach(key => {
                let flag = false;
                switch (key) {
                  case 'distance':
                  case 'mirror_distance':
                    if (+track.params[key]) {
                      flag = true;
                    }
                    break;
                  case 'radius':
                    if (+track.params[key] && track.effectType === 'gaussianBlur') {
                      flag = true;
                    }
                    break;
                }

                if (flag) {
                  params[key] = track.params[key] * factor;
                } else {
                  params[key] = track.params[key];
                }
              });
            }
            return {
              ...track,
              params
            };
          }
          return track;
        })
      };
    };

    const content = selectedEffectIds.map(id => {
      const effect = effects[id];
      return {
        ...reverseEffectScale(effect),
        container: undefined,
        children: effect.children
          ? effect.children.map(cid => ({
            ...reverseEffectScale(effects[cid]),
            container: undefined
          }))
          : undefined
      };
    });
    const specs = screenRatio > 1 ? 1 : screenRatio === 1 ? 2 : 3;

    switch (type) {
      case 'preset':
        return post('assembly/create', {
          name,
          thumbnail: url,
          specs,
          content
        });
      case 'combination':
        return post('assembly/share_to_text', {
          name,
          file: url,
          specs,
          content
        });
      default:
        message.error('Unsupported type');
    }
  },
  async getTagData({ commit }) {
    const ret = await get('custom/material-label');
    const lookup = {};
    const handleSingleTag = t => {
      lookup[t.material_label_id] = t.name;
      if (t.lower) {
        t.lower.forEach(handleSingleTag);
      }
      if (t.text) {
        t.text.forEach(handleSingleTag);
      }
    };
    Object.keys(ret).forEach(k => {
      const obj = ret[k];
      obj.lower.forEach(handleSingleTag);
      Object.keys(obj.common_text).forEach(tk => {
        handleSingleTag(obj.common_text[tk]);
      });
    });
    console.log(ret);
    console.log(lookup);
    commit('handleVideoSeriesTagData', ret);
    commit('handleVideoSeriesTagNames', lookup);
  },
  addCoverText({ state }) {
    state.coverParams.push({
      text: 'Text',
      top: 0,
      left: 0,
      width: 200,
      height: 58,
      rotate: 0,
      opacity: 100,
      fontSize: 40,
      fontFamily: 'Montserrat-Bold',
      autoFontSize: true,
      color: '#333',
      useShadow: false,
      shadow: {
        x: 0,
        y: 3,
        blur: 8,
        color: 'rgba(0,0,0,.3)'
      },
      align: 'center',
      lineHeight: 1.4,
      stroke: '#49e',
      strokeWidth: 0,
      verticalAlign: 'middle',
      letterSpacing: 0
    });
  },
  async addCoverSticker({ state, commit }, { id, thumbnail: url }) {
    commit('handleLoading', true);
    addClickCount(id);
    const resp = await getSVGData(url);
    commit('handleLoading', false);

    const { aspectRatio, source } = normalizeSVGSource(resp.data);

    state.coverParams.push({
      type: 'sticker',
      top: 0,
      left: 0,
      width: 120,
      height: 120 / aspectRatio,
      rotate: 0,
      opacity: 100,
      useShadow: false,
      shadow: {
        x: 0,
        y: 3,
        blur: 8,
        color: 'rgba(0,0,0,.3)'
      },
      stickerHTML: source
    });
  },
  removeCoverTextAt({ state }, index) {
    state.coverParams.splice(index, 1);
  },
  async getVideoScriptList({ state, commit }, { page = 1, type, scene, keyword }) {
    const { total, data } = await get('script/open-list', {
      page,
      limit: 10,
      kind: type,
      option_id: scene,
      keyword: keyword
    });
    commit('handleVideoScripts', [].concat(page > 1 ? state.videoScripts : [], data));
    return {
      lastPage: page * 10 >= total
    };
  },
  async getVideoScriptSceneTypes({ commit }) {
    const [scenes, types] = await Promise.all([
      get('script/open-shooting'),
      get('script/open-kind')
    ]);

    commit('handleVideoScriptScenes', scenes.map(({ id, name }) => ({ name, value: id })));
    commit('handleVideoScriptTypes', types);
  },
  async getMusicCategoryList({ commit }) {
    const data = await get('material/category-list', { material_type: 6 });
    const list = [{ id: '', cn_name: '全部' }].concat(
      data[1].category_list.map(obj => ({
        ...obj,
        cn_name: obj.name
      }))
    );
    commit('handleMusicCategoryList', list);
  },
  getUploadSpace,
  uploadToOSS,
  addCustomTTS,
  changeCustomTTS,
  removeCustomTTS
};
